/// <reference path="../../polaris-web-components.d.ts" />
import React, { useEffect, useMemo, useState, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { environment } from '../Services/environment';
import { getMappedTemplates } from '../Services/CommonServices';
import SettingsConfig from './ProductSettingsConfig';
import MappingTabs from '../common/MappingTabs';
import '.././CSS/setup.module.css';
const endpoint = environment.serverUrl;

const encodeOptionValue = (val, arr) => {
  if (!arr) return val ?? 'null';
  if (val === null || val === undefined) return 'null';
  const trimmed = typeof val === 'string' ? val.trim() : String(val);
  const idx = arr.findIndex(h => (typeof h === 'string' ? h.trim() : String(h)) === trimmed);
  return idx >= 0 ? String(idx) : 'null';
};
const decodeOptionValue = (idxStr, arr) => {
  if (!arr || idxStr === 'null' || idxStr === null || idxStr === undefined) return 'null';
  const idx = parseInt(idxStr, 10);
  if (isNaN(idx) || idx < 0 || idx >= arr.length) return 'null';
  const val = arr[idx];
  return typeof val === 'string' ? val.trim() : String(val);
};

export default function CSVMapping({ cancelUpload, uploadError, submitUpload, csvHeaders, incomingShopifyHeaders, activate, file, storeUrl, dbTagSeparator, currentRoute, uploadType, ftpConfig, templateEditId, setCompletedSteps, setSelectedTemplateId }) {
  const [headerMappings, setHeaderMappings] = useState([]);
  const [tagsStructure, setTagsStructure] = useState([]);
  const [tagseparator, setTagseparator] = useState(dbTagSeparator);
  const [metafieldStructures, setMetafieldStructures] = useState([]);
  const [showImageModal, setShowImageModal] = useState(false);
  const [metafieldErrors, setMetafieldErrors] = useState(Array(metafieldStructures.length).fill(undefined));
  const [metaKeyLengthErrors, setMetaKeyLengthErrors] = useState(Array(metafieldStructures.length).fill(undefined));
  const [metafieldNamespaceErrors, setMetafieldNamespaceErrors] = useState(Array(metafieldStructures.length).fill(undefined));
  const [metaTypeErrors, setMetaTypeErrors] = useState(Array(metafieldStructures.length).fill(undefined));
  const [metaCsvHeaderErrors, setMetaCsvHeaderErrors] = useState(Array(metafieldStructures.length).fill(undefined));
  const [tagsPrefixErrors, setTagsPrefixErrors] = useState(Array(tagsStructure.length).fill(undefined));
  const [tagsSuffixErrors, setTagsSuffixErrors] = useState(Array(tagsStructure.length).fill(undefined));
  const [productErrors, setProductErrors] = useState(Array(headerMappings.length).fill(undefined));
  const [productVariantOptionErrors, setProductVariantOptionErrors] = useState(Array(headerMappings.length).fill(undefined));
  const [shopifyHeaders, setShopifyHeaders] = useState([]);
  const [headersCSV, setHeadersCSV] = useState([]);

  const [selectedCsvHeader, setSelectedCsvHeader] = useState('');
  const [selectedShopifyHeader, setSelectedShopifyHeader] = useState('');
  const [hasUserSelection, setHasUserSelection] = useState(false);
  const [active, setActive] = useState(false);
  const [metafieldNamespace, setMetafieldNamespace] = useState('');
  const [metafieldKey, setMetafieldKey] = useState('');
  const [metafieldParent, setMetafieldParent] = useState('product');
  const [showMetafieldModalAdd, setShowMetafieldModalAdd] = useState(false);
  const [showMetafieldModalEdit, setShowMetafieldModalEdit] = useState(false);
  const [showTagsModal, setShowTagsModal] = useState(false);
  const metafieldTypeOptions = useMemo(() =>
    ['null', 'boolean', 'color', 'date', 'date_time', 'dimension', 'json', 'money', 'multi_line_text_field', 'number_decimal',
      'number_integer', 'rating', 'rich_text_field', 'string', 'single_line_text_field', 'url', 'volume', 'weight', 'collection_reference', 'file_reference',
      'metaobject_reference', 'mixed_reference', 'page_reference', 'product_reference', 'variant_reference', 'list.collection_reference', 'list.color',
      'list.date', 'list.date_time', 'list.dimension', 'list.file_reference', 'list.metaobject_reference', 'list.mixed_reference', 'list.number_integer',
      'list.number_decimal', 'list.page_reference', 'list.product_reference', 'list.rating', 'list.single_line_text_field', 'list.url', 'list.variant_reference',
      'list.volume', 'list.weight'].map((type) => ({ label: type == 'null' ? "Select a value" : type, value: type }))
    , []);
  const [selectedMetafieldType, setSelectedMetafieldType] = useState('single_line_text_field');
  const [addPrefix, setAddPrefix] = useState(false);
  const [tagPrefix, setTagPrefix] = useState('');
  const [selectedImageSrc, setSelectedImageSrc] = useState('');
  const [selectedImageAlt, setSelectedImageAlt] = useState('');
  const [selectedImageId, setSelectedImageId] = useState('');
  const [imagePairs, setImagePairs] = useState([]);
  const [imageLayout, setImageLayout] = useState('column');
  const [separator, setSeparator] = useState(',');
  const [selectedCsvHeaderForItem, setSelectedCsvHeaderForItem] = useState('');
  const [indexTableLoading, setIndexTableLoading] = useState(false);
  const handleAddImagePair = useCallback(() => {
    if (selectedImageSrc && selectedImageAlt) {
      const newImagePair = {
        // imageId: selectedImageId,
        imageSrc: selectedImageSrc,
        imageAlt: selectedImageAlt,
        layout: imageLayout,
        separator: separator,
      };
      setImagePairs([...imagePairs, newImagePair]);
      setSelectedImageSrc('');
      setSelectedImageAlt('');
      setSelectedImageId('');
      setSeparator(',');

    }
  }, [selectedImageSrc, selectedImageAlt, imageLayout, separator, imagePairs]);

  const handleMappingDone = useCallback(() => {
    console.log("CSV Mapping Done");
    if (currentRoute !== "product" && setCompletedSteps) { setCompletedSteps((prev) => ({ ...prev, step2: true })); }
  }, [currentRoute, setCompletedSteps]);

  // Helper function to check if we have valid header data
  const hasValidHeaders = useMemo(() => {
    const hasCSV = headersCSV && headersCSV.length > 0 &&
      !(headersCSV.length === 1 && headersCSV[0] === "null");
    const hasShopify = shopifyHeaders && shopifyHeaders.length > 0 &&
      !(shopifyHeaders.length === 1 && shopifyHeaders[0] === "null");

    console.log("✅ hasValidHeaders check:", {
      hasCSV,
      hasShopify,
      result: hasCSV && hasShopify,
      csvLength: headersCSV?.length,
      shopifyLength: shopifyHeaders?.length,
      csvFirst: headersCSV?.[0],
      shopifyFirst: shopifyHeaders?.[0]
    });
    return hasCSV && hasShopify;
  }, [headersCSV, shopifyHeaders]);

  // Open modal programmatically when activate prop is true AND data is loaded
  useEffect(() => {
    const modal = document.getElementById('mapping-modal');

    console.log("🔍 MODAL EFFECT TRIGGERED:", {
      activate,
      hasValidHeaders,
      modalExists: !!modal,
      csvLength: headersCSV?.length,
      shopifyLength: shopifyHeaders?.length,
      csvFirst3: headersCSV?.slice(0, 3),
      shopifyFirst3: shopifyHeaders?.slice(0, 3)
    });

    if (modal) {
      // Only open modal if we have valid data
      if (activate && hasValidHeaders) {
        console.log("✅ OPENING MODAL - All conditions met!");
        try {
          modal.showOverlay();
          console.log("✅ Modal.showOverlay() called successfully");
        } catch (error) {
          console.error("❌ Error calling showOverlay():", error);
        }
      } else if (!activate) {
        console.log("🔒 Closing modal (activate=false)");
        modal.hideOverlay();
      } else {
        console.warn("⚠️ MODAL NOT OPENING - Waiting for conditions:", {
          activate,
          hasValidHeaders,
          csvLength: headersCSV.length,
          shopifyLength: shopifyHeaders.length,
          needsActivate: !activate,
          needsValidHeaders: !hasValidHeaders
        });
      }
    } else {
      console.error("❌ Modal element not found with ID 'mapping-modal'");
    }
  }, [activate, hasValidHeaders, headersCSV.length, shopifyHeaders.length]);

  const handleAddPrefixChange = useCallback((newValue) => {
    setAddPrefix(newValue);
  }, []);

  // const handleATagSeparatorChange = (newValue) => {
  //   console.log("handleATagSeparatorChange newValue", newValue);
  //   setTagseparator(newValue);
  // };
  const [addedItems, setAddedItems] = useState([]);

  const handleRemoveItem = useCallback((index) => {
    const updatedItems = addedItems.filter((item, i) => i !== index);
    setAddedItems(updatedItems);
  }, [addedItems]);
  const [mappingMetafieldError, setMetafieldMappingError] = useState("");
  const handleAddItem = useCallback(() => {
    if (!addedItems.includes(selectedCsvHeaderForItem)) {
      setAddedItems([...addedItems, selectedCsvHeaderForItem]);
    }
  }, [addedItems, selectedCsvHeaderForItem]);

  const [showTemplateNameModal, setShowTemplateNameModal] = useState(false);
  const [templateName, setTemplateName] = useState('');
  const [selectedTemplate, setSelectedTemplate] = useState("0");
  const [saveTempLoading, setSaveTempLoading] = useState(false);
  const [tempLoading, setTempLoading] = useState(false);
  const [existingTemplates, setExistingTemplates] = useState([]);
  const [mappingProductError, setProductMappingError] = useState("");
  const [selected, setSelected] = useState(0);
  const [showSettingsConfigModal, setShowSettingsConfigModal] = useState(false);
  const onCloseSettingsModal = useCallback(() => {
    setShowSettingsConfigModal(false);
  }, []);
  const [newEntryValidationError, setNewEntryValidationError] = useState("");
  // default mapping values 
  // const productDefaultMapping = {
  //   csvHeader: csvHeaders[0] ?? "null",
  //   shopifyHeaders: [
  //     {
  //       type: 'normal',
  //       separator: null,
  //       header: csvHeaders[0] ?? "null",
  //     },
  //   ],
  // };

  const productDefaultMapping = {
    csvHeader: "null",
    shopifyHeaders: [
      {
        type: 'normal',
        separator: null,
        header: "null",
      },
    ],
  };

  // const imageMappingDefaultValue = {
  //   imageSrc: csvHeaders[0] ?? "null",
  //   imageAlt: incomingShopifyHeaders[0] ?? "null",
  //   layout: "column",
  //   separator: ","
  // }

  const imageMappingDefaultValue = {
    imageSrc: "null",
    imageAlt: "null",
    layout: "column",
    separator: ","
  }

  const tagsDefaultMapping = {
    separator: '',
    prefix: '',
    suffix: '',
    mappedHeader: "null"
  }

  const metafieldDefaultMapping = {
    namespace: "",
    key: "",
    type: selectedMetafieldType,
    metafieldParent: "product",
    csvHeaders: "null"
  }
  


  // default mapping end
  useEffect(() => {
    console.log("selected integration", csvHeaders[0]);
    setActive(activate);
    setHeadersCSV(csvHeaders);
    setSelectedCsvHeader(csvHeaders[0]);
    setSelectedImageSrc(csvHeaders[0]);
    setSelectedImageAlt(csvHeaders[0]);
    setSelectedImageId(csvHeaders[0]);
    setSelectedCsvHeaderForItem(csvHeaders[0]);
    setSelectedCsvHeaderForTags(csvHeaders[0]);
    if (currentRoute !== "order" && currentRoute !== "preset") { getTemplates(); }
    mapDefaultValues();
    console.log("edit csvHeaders ", csvHeaders);
    console.log("edit incomingShopifyHeaders called", incomingShopifyHeaders);
    fetchShopifyHeaders();
    console.log("currentRoute products file upload before", currentRoute, uploadType);
    if (currentRoute === "product" && uploadType === "File") {
      console.log("currentRoute products file upload", currentRoute, uploadType);

      autoMapHeaders(csvHeaders, incomingShopifyHeaders);
    }
    setIndexTableLoading(true);
    setShopifyHeaders(incomingShopifyHeaders);
    console.log("headers=", incomingShopifyHeaders, csvHeaders);
    console.log("headers=state", headersCSV, shopifyHeaders);
  }, [activate, csvHeaders, incomingShopifyHeaders]);

  // Log state values AFTER they update (separate useEffect to see populated values)
  useEffect(() => {
    console.log("STATE UPDATED - headersCSV:", headersCSV, "length:", headersCSV.length, uploadType);
    console.log("STATE UPDATED - shopifyHeaders:", shopifyHeaders, "length:", shopifyHeaders.length);

    // Check if we have valid data (not just ["null"])
    const hasValidCSVHeaders = headersCSV.length > 0 && !(headersCSV.length === 1 && headersCSV[0] === "null");
    const hasValidShopifyHeaders = shopifyHeaders.length > 0 && !(shopifyHeaders.length === 1 && shopifyHeaders[0] === "null");

    console.log("Has valid CSV headers:", hasValidCSVHeaders);
    console.log("Has valid Shopify headers:", hasValidShopifyHeaders);
  }, [headersCSV, shopifyHeaders, uploadType]);

  useEffect(() => {
    console.log("currentRoute", currentRoute);

    if (currentRoute === "preset" && (templateEditId === "0" || templateEditId === 0 || templateEditId === null || templateEditId === undefined)) {
      setIndexTableLoading(true);
      autoMapHeaders(csvHeaders, incomingShopifyHeaders);
    }
  }, currentRoute === "order" ? [] : [existingTemplates]);



  useEffect(() => {
    if (templateEditId) {
      console.log("templateEditId asas", templateEditId, "uploadType", uploadType);
      getTemplates();
    }
  }, [templateEditId, uploadType]);



  //Default mappings 

  const mapDefaultValues = () => {

    if (headerMappings.length === 0) {
      const hasNullMapping = headerMappings.some(mapping => mapping.csvHeader === "null" || mapping.shopifyHeaders.some(shopifyHeader => shopifyHeader.header === "null"));
      if (!hasNullMapping) {
        productDefaultMapping.csvHeader = csvHeaders[0];
        productDefaultMapping.shopifyHeaders[0].header = incomingShopifyHeaders[0];
        setHeaderMappings([productDefaultMapping]);
      }
    }

    if (imagePairs.length === 0) {
      const hasImgNullMapping = imagePairs.some(mapping => mapping.imageSrc === "null" || mapping.imageAlt === "null");
      if (!hasImgNullMapping) {
        setImagePairs([imageMappingDefaultValue]);
      }
    }

    if (tagsStructure.length === 0) {
      const hasTagNullMapping = tagsStructure.some(mapping => mapping.mappedHeader === "null");
      if (!hasTagNullMapping) {
        setTagsStructure([tagsDefaultMapping]);
      }
    }

    if (metafieldStructures.length === 0) {
      const hasMetaNullMapping = metafieldStructures.some(mapping => mapping.csvHeaders === "null");
      if (!hasMetaNullMapping) {
        setMetafieldStructures([metafieldDefaultMapping]);
      }
    }
  }

  /// default map end //////////

  const fetchShopifyHeaders = () => {
    // const shopifyHeaders = [
    //   'null', 'Product Id', 'Handle', 'Title', 'Body (HTML)', 'Template Suffix', 'Vendor', 'Type', 'Tags', 'Published At', 'Published',
    //   'Option1 Id','Option1 Name', 'Option1 Value','Option2 Id', 'Option2 Name', 'Option2 Value','Option3 Id', 'Option3 Name', 'Option3 Value','Variant Id',
    //   'Variant Sku', 'Variant Inventory Tracker', 'Variant Inventory Qty', 'Variant Inventory Policy',
    //   'Variant Price', 'Variant Compare At Price', 'Variant Requires Shipping', 'Variant Taxable', 'Variant Barcode',
    //   'Image', 'Media Src', 'Media Alt', 'Gift Card', 'Seo Title', 'Seo Description', 'Variant Image', 'Variant ImageAlt',
    //   'Variant Weight', 'Variant Weight Unit', 'Metafield', 'Variant Tax Code', 'Variant HSN', 'Status',"Product Category","Cost per item"
    // ];

    setSelectedShopifyHeader('');
    setHasUserSelection(true);
    setShopifyHeaders(incomingShopifyHeaders);
  };

  useEffect(() => {
  }, [shopifyHeaders]);

  const [mappedShopifyHeaders, setMappedShopifyHeaders] = useState(new Set());

  const handleRemoveMapping = (csvHeaderToRemove, shopifyHeaderToRemove, index) => {
    setNewEntryValidationError("");

    // If only one mapping exists, reset to default instead of removing
    if (headerMappings.length === 1) {
      setHeaderMappings([productDefaultMapping]);
      setProductErrors([]);
      setProductVariantOptionErrors([]);
      setMappedShopifyHeaders(new Set());
      return;
    }

    const productError = productErrors.filter((_, index1) => index1 !== index);
    setProductErrors(productError);
    const variantErrors = productVariantOptionErrors.filter((_, index1) => index1 !== index);
    setProductVariantOptionErrors(variantErrors);
    // const newErrors = [...productErrors];
    // newErrors[index] = undefined;
    // setProductErrors(newErrors);
    setMappedShopifyHeaders((prevMappedHeaders) => {
      const updatedHeaders = new Set(prevMappedHeaders);
      updatedHeaders.delete(shopifyHeaderToRemove);
      return updatedHeaders;
    });
    const updatedMappings = headerMappings.map(mapping => {
      if (mapping.csvHeader === csvHeaderToRemove) {
        return {
          ...mapping,
          shopifyHeaders: mapping.shopifyHeaders.filter(h => h.header !== shopifyHeaderToRemove),
        };
      }
      return mapping;
    });

    const filteredMappings = updatedMappings.filter(mapping => mapping.shopifyHeaders.length > 0);
    
    if (filteredMappings.length === 0) {
      setHeaderMappings([productDefaultMapping]);
    } else {
      setHeaderMappings(filteredMappings);
    }
  };

  // const normalizeHeader = (header) => header.toLowerCase().replace(/[^\w\s]/g, '').replace(/\s+/g, '');
  const normalizeHeader = useCallback((header) => {
    let normalizedHeader = header.toLowerCase().replace(/[^\w\s]/g, '').replace(/\s+/g, '');
    if (normalizedHeader.includes('location')) {
      normalizedHeader = normalizedHeader.replace('active', '');
    }
    return normalizedHeader;
  }, []);

  // Define validateVariantOptionMappings before autoMapHeaders to avoid initialization error
  const validateVariantOptionMappings = useCallback((headers) => {
    var variantErrors = [];
    headers.forEach((mapping, index) => {
      mapping.shopifyHeaders.forEach((shopifyHeader) => {
        const { header } = shopifyHeader;

        if (header?.includes('Value') || header?.includes('Name')) {
          const correspondingHeader = header?.includes('Value') ? header.replace(' Value', ' Name') : header.replace(' Name', ' Value');

          const isNameExists = headers.some(
            (m) => m.shopifyHeaders.find((sh) => sh.header === correspondingHeader)
          );

          const isValueExists = headers.some(
            (m) => m.shopifyHeaders.find((sh) => sh.header === header)
          );

          if (isNameExists && !isValueExists) {
            variantErrors[index] = header + ' is required.';
          } else if (isValueExists && !isNameExists) {
            variantErrors[index] = correspondingHeader + ' is required.';
          } else {
            variantErrors[index] = undefined;
            // Clear the error for the corresponding header
            const correspondingIndex = headers.findIndex(
              (m) => m.shopifyHeaders.find((sh) => sh.header === correspondingHeader)
            );
            if (correspondingIndex !== -1) {
              variantErrors[correspondingIndex] = undefined;
            }
          }
        }
      });
    });

    setProductVariantOptionErrors(variantErrors);
  }, []);

  // const autoMapHeaders = () => {
  const autoMapHeaders = useCallback((csvHeaders, shopifyHeaders) => {
    console.log("currentRoute Auto-mapping headers called", csvHeaders, shopifyHeaders);
    const newMappings = [];
    const newMetafieldMappings = [];
    let newImageMappings = {};
    const newTagsMappings = [];
    let imageHeaderSrc = null;
    let imageHeaderAlt = null;

    for (const csvHeader of csvHeaders) {
      if (csvHeader != "null") {
        const normalizedCsvHeader = normalizeHeader(csvHeader);
        const matchingShopifyHeaders = shopifyHeaders.filter(
          header => normalizeHeader(header) === normalizedCsvHeader
        );
        if (matchingShopifyHeaders.length > 0) {

          const mappings = [];
          matchingShopifyHeaders.forEach(matchingHeader => {
            let headerToAdd = (matchingHeader && matchingHeader.trim().toLowerCase().replace(/[^\w\s]/g, '').replace(/\s+/g, ''));
            if (headerToAdd === 'imagesrc') {
              imageHeaderSrc = 'Image Src';
            } else if (headerToAdd === 'mediasrc') {
              imageHeaderSrc = 'Media Src';
            }
            if (headerToAdd === 'imagealt') {
              imageHeaderAlt = 'Image Alt';
            } else if (headerToAdd === 'mediaalt') {
              imageHeaderAlt = 'Media Alt';
            }

            if (headerToAdd === 'tags') {
              const tagMapping = {
                separator: tagseparator ?? ',',
                prefix: '',
                suffix: '',
                mappedHeader: csvHeader,
              };
              newTagsMappings.push(tagMapping);
              return;
            }

            if (['mediasrc', 'mediaalt', 'imagesrc', 'imagealt'].includes(headerToAdd)) {
              headerToAdd = 'images';
            } else {
              headerToAdd = 'normal';
            }
            const separatorToAdd = null;
            setMappedShopifyHeaders(prevMappedHeaders => new Set(prevMappedHeaders).add(matchingHeader));

            mappings.push({
              type: headerToAdd,
              separator: separatorToAdd,
              header: matchingHeader,
            });
          });

          if (mappings.length > 0) {
            const newMapping = {
              csvHeader: csvHeader,
              shopifyHeaders: mappings,
            };
            if (newMapping.shopifyHeaders[0].type !== "images") {
              newMappings.push(newMapping);
            } else {
              const newImagePair = {
                imageSrc: imageHeaderSrc,
                imageAlt: imageHeaderAlt,
                layout: imageLayout,
                separator: separator,
              };
              newImageMappings = newImagePair;
            }
          }

        }
        else if (currentRoute !== "order" ? csvHeader.includes('product/') : csvHeader.includes('order/')) {
          const [metafieldParent, namespace, key, type] = csvHeader.split('/');
          if (currentRoute !== "order" ? metafieldParent === 'product' : metafieldParent === 'order') {
            const metafieldMapping = {
              namespace: namespace,
              key: key,
              type: type === "json" ? "jsonAutomap" : type?.startsWith('list.') ? type : type,
              metafieldParent: metafieldParent,
              csvHeaders: csvHeader,
            };
            newMetafieldMappings.push(metafieldMapping);
          }
        }

        else if (csvHeader.includes('variant/')) {
          const [metafieldParent, namespace, key, type] = csvHeader.split('/');
          if (metafieldParent === 'variant') {
            const metafieldMapping = {
              namespace: namespace,
              key: key,
              type: type === "json" ? "jsonAutomap" : type?.startsWith('list.') ? type : type,
              metafieldParent: metafieldParent,
              csvHeaders: csvHeader,
            };
            newMetafieldMappings.push(metafieldMapping);
          }
        }

        else if (csvHeader.includes('tag/')) {
          const [keyword, prefix] = csvHeader.split('/');
          const tagMapping = {
            separator: null,
            prefix: prefix,
            suffix: null,
            mappedHeader: csvHeader,
          };
          console.log("result tagMapping", tagMapping);
          newTagsMappings.push(tagMapping);
        }
      }
    }
    if (newMappings.length > 0) {
      const filteredNewMappings = newMappings.filter(mapping => mapping.csvHeader !== "null");
      setHeaderMappings([...filteredNewMappings]);
    }
    else {
      setHeaderMappings([productDefaultMapping]);
    }
    if (Object.keys(newImageMappings).length > 0) {
      if (newImageMappings.imageAlt !== "null" && newImageMappings.imageSrc !== "null") {
        setImagePairs([newImageMappings]);
      }
    }
    else {
      setImagePairs([imageMappingDefaultValue])
    }
    if (newTagsMappings.length > 0) {
      const filteredNewMappings = newTagsMappings.filter(mapping => mapping.mappedHeader !== "null");
      setTagsStructure([...filteredNewMappings]);
    }
    else {
      setTagsStructure([tagsDefaultMapping]);
    }
    if (newMetafieldMappings.length > 0) {
      const filteredNewMappings = newMetafieldMappings.filter(mapping => mapping.csvHeaders !== "null");
      setMetafieldStructures([...filteredNewMappings]);
    }
    else {
      setMetafieldStructures([metafieldDefaultMapping]);
    }
    const newErrors = Array(newMetafieldMappings.length).fill(undefined);
    const newTypeErrors = Array(newMetafieldMappings.length).fill(undefined);
    const newNamespaceErrors = Array(newMetafieldMappings.length).fill(undefined);
    const newKeyErrors = Array(newMetafieldMappings.length).fill(undefined);
    newMetafieldMappings.forEach((metafieldMapping, mappingIndex) => {
      const isTypeInOptions = metafieldTypeOptions.some((option) => option.value === (metafieldMapping.type === "jsonAutomap" ? "json" : metafieldMapping.type));
      if (!isTypeInOptions) {
        newTypeErrors[mappingIndex] = 'Type is required.';
      }
      if (metafieldMapping.key && metafieldMapping.key.length > 0 && metafieldMapping.key.length < 3) {
        newKeyErrors[mappingIndex] = 'minimum is 3 characters.';
      }
      if (metafieldMapping.namespace && metafieldMapping.namespace.length > 0 && metafieldMapping.namespace.length < 3) {
        newNamespaceErrors[mappingIndex] = 'minimum is 3 characters.';
      }
    });
    const seenKeys = {};
    newMetafieldMappings.forEach((metafieldMapping, mappingIndex) => {
      if (metafieldMapping.key !== "null") {
        const keyWithNamespace = `${metafieldMapping.namespace}:${metafieldMapping.key}:${metafieldMapping.metafieldParent}:${metafieldMapping.type}`;
        if (seenKeys[keyWithNamespace]) {
          newErrors[mappingIndex] = 'Key already exists within the same namespace.';
        } else {
          seenKeys[keyWithNamespace] = true;
        }
      }

    });
    validateVariantOptionMappings(headerMappings);
    setMetaTypeErrors(newTypeErrors);
    setMetafieldErrors(newErrors);
    setMetaKeyLengthErrors(newKeyErrors);
    setMetafieldNamespaceErrors(newNamespaceErrors)
    setIndexTableLoading(false);

  }, [normalizeHeader, currentRoute, metafieldTypeOptions, productDefaultMapping, imageMappingDefaultValue, tagsDefaultMapping,
    metafieldDefaultMapping, imageLayout, separator, tagseparator, validateVariantOptionMappings]);





  const handleClearAllMappings = useCallback(() => {
    setHeaderMappings([productDefaultMapping]);
    setTagsStructure([tagsDefaultMapping]);
    setMetafieldStructures([metafieldDefaultMapping]);
    setImagePairs([imageMappingDefaultValue]);
    setMappedShopifyHeaders(new Set());
    setProductErrors(Array(headerMappings.length).fill(undefined))
    setMetafieldErrors(Array(metafieldStructures.length).fill(undefined))
    setMetafieldNamespaceErrors(Array(metafieldStructures.length).fill(undefined))
    setMetaTypeErrors(Array(metafieldStructures.length).fill(undefined))
    setMetaKeyLengthErrors(Array(metafieldStructures.length).fill(undefined))
    setMetaCsvHeaderErrors(Array(metafieldStructures.length).fill(undefined))
    setProductVariantOptionErrors(Array(headerMappings.length).fill(undefined))
  }, [productDefaultMapping, tagsDefaultMapping, metafieldDefaultMapping, imageMappingDefaultValue,
    headerMappings.length, metafieldStructures.length]);


  const handleMetafieldTypeChange = useCallback((selected) => {
    setSelectedMetafieldType(selected);
  }, []);

  const handleRemoveImagePair = useCallback((index) => {
    const updatedImagePairs = [...imagePairs];
    updatedImagePairs.splice(index, 1);
    setImagePairs(updatedImagePairs);
  }, [imagePairs]);

  const handleImageRemove = useCallback((indexToRemove) => {
    // If only one image pair exists, reset to default instead of removing
    if (imagePairs.length === 1) {
      setImagePairs([imageMappingDefaultValue]);
      setSelectedImageSrc(csvHeaders[0]);
      setSelectedImageAlt(csvHeaders[0]);
      setSelectedImageId(csvHeaders[0]);
      return;
    }

    setSelectedImageSrc(csvHeaders[0]);
    setSelectedImageAlt(csvHeaders[0]);
    setSelectedImageId(csvHeaders[0]);
    const updatedImagePairs = imagePairs.filter((_, index) => index !== indexToRemove);
    setImagePairs(updatedImagePairs);
  }, [imagePairs, imageMappingDefaultValue, csvHeaders]);

  const imagePairsMarkup = useMemo(() => imagePairs.map(
    (
      { imageSrc, imageAlt, layout, separator },
      index,
    ) => (
      <s-table-row key={`${imageSrc}-${index}`}>
        {/* <s-table-cell>
          <s-text>{imageId}</s-text>
        </s-table-cell> */}
        <s-table-cell>
          <s-text>{imageSrc}</s-text>
        </s-table-cell>
        <s-table-cell>
          <s-text>{imageAlt}</s-text>
        </s-table-cell>
        <s-table-cell>
          <s-text>{layout}</s-text>
        </s-table-cell>
        <s-table-cell>
          {layout === 'row' ? <s-text>{separator}</s-text> : <s-text color="subdued">N/A</s-text>}
        </s-table-cell>
        <s-table-cell>
          <div style={{ color: '#bf0711' }}>
            <s-button onClick={() => handleImageRemove(index)} variant="plain" tone="critical" size="micro"></s-button>
          </div>
        </s-table-cell>
      </s-table-row>
    ),
  ), [imagePairs, handleImageRemove]);

  const imageModal = (
    <s-modal
      id="image-modal"
      heading="Select Images"
    >
      <s-modal-section>
        <s-stack direction="block">
          {/* <s-select 
            label="Select Column Header for Media Id"
            value={selectedImageId}
            onChange={(e) => setSelectedImageId(e.currentTarget.value)}
          >
            {headersCSV.map((header) => (
              <s-option key={header} value={header}>{header}</s-option>
            ))}
          </s-select> */}
          <s-select
            label="Select Column Header for Media Source"
            value={encodeOptionValue(selectedImageSrc, headersCSV)}
            onChange={(e) => setSelectedImageSrc(decodeOptionValue(e.currentTarget.value, headersCSV))}
          >
            {headersCSV.map((header, i) => (
              <s-option key={`img-src-${i}`} value={String(i)}>{header}</s-option>
            ))}
          </s-select>
          <s-select
            label="Select Column Header for Media Alt"
            value={encodeOptionValue(selectedImageAlt, headersCSV)}
            onChange={(e) => setSelectedImageAlt(decodeOptionValue(e.currentTarget.value, headersCSV))}
          >
            {headersCSV.map((header, i) => (
              <s-option key={`img-alt-${i}`} value={String(i)}>{header}</s-option>
            ))}
          </s-select>
          <div>
            <p>Select Image Layout:</p>
            <label>
              <input
                type="radio"
                name="imageLayout"
                checked={imageLayout === 'row'}
                onChange={() => setImageLayout('row')}
              /> Row-wise
            </label>
            <br />
            <label>
              <input
                type="radio"
                name="imageLayout"
                checked={imageLayout === 'column'}
                onChange={() => setImageLayout('column')}
              /> Column-wise
            </label>
          </div>
          {imageLayout === 'row' && (
            <s-text-field
              label="Image Separator"
              value={separator}
              onChange={(value) => setSeparator(typeof value === 'string' ? value : (value?.target?.value ?? value?.currentTarget?.value ?? ''))}
            />
          )}
          {(selectedImageSrc && selectedImageAlt) && (
            <s-button onClick={handleAddImagePair}>Add Pair</s-button>
          )}

        </s-stack>
        {imagePairs.length > 0 ?
          <s-box>
            <s-stack direction="block" gap="tight">
              <s-heading>
                Items mapped
              </s-heading>
              <s-table>
                <s-table-header-row>
                  <s-table-header>Media src</s-table-header>
                  <s-table-header>Media alt</s-table-header>
                  <s-table-header>Layout</s-table-header>
                  <s-table-header>Separator</s-table-header>
                </s-table-header-row>
                <s-table-body>{imagePairsMarkup}</s-table-body>
              </s-table>
            </s-stack>
          </s-box>
          : null}
      </s-modal-section>

      <s-button
        slot="primary-action"
        variant="primary"
        commandFor="image-modal"
        command="--hide"
        onClick={() => {
          handleAddImagePair();
        }}
      >
        Add Images
      </s-button>
    </s-modal>
  );

  const createJsonStructure = useCallback(() => {
    const jsonStructure = {};

    addedItems.forEach((item) => {
      jsonStructure[item] = 'The value from the Column header goes here.';
    });

    return jsonStructure;
  }, [addedItems]);

  const handleAddMappingAndCreateMetafield = () => {
    const newMetafieldStructure = createMetafieldStructure();
    const isUniqueMetafield = !metafieldStructures.some(
      (existingMetafield) =>
        existingMetafield.parent === newMetafieldStructure.parent &&
        existingMetafield.key === newMetafieldStructure.key && existingMetafield.type === newMetafieldStructure.type
    );

    if (isUniqueMetafield) {
      setMetafieldStructures([...metafieldStructures, newMetafieldStructure]);
      setSelectedCsvHeader(headersCSV[0]);
      setSelectedCsvHeaderForItem(headersCSV[0]);
      if (mappingMetafieldError === "") {
        setShowMetafieldModalAdd(false);
      }
    } else {
      setMetafieldMappingError("Metafield with the same key already exists.");
    }
  };

  const handleEditMappingAndCreateMetafield = () => {
    const newMetafieldStructure = createMetafieldStructure();
    const index = metafieldStructures.findIndex(
      (existingMetafield) =>
        existingMetafield.parent === newMetafieldStructure.parent &&
        existingMetafield.key === newMetafieldStructure.key
    );

    if (index !== -1) {
      const updatedMetafieldStructures = [...metafieldStructures];
      updatedMetafieldStructures.splice(index, 1);
      updatedMetafieldStructures.splice(index, 0, newMetafieldStructure);
      setMetafieldStructures(updatedMetafieldStructures);
      setSelectedCsvHeader(headersCSV[0]);
      setSelectedCsvHeaderForItem(headersCSV[0]);
      if (mappingMetafieldError === "") {
        setShowMetafieldModalEdit(false);
      }
    } else {
      setMetafieldMappingError("Metafield doesnt exist.");
    }
  };


  const createMetafieldStructure = () => {
    const metafieldStructure = {
      namespace: metafieldNamespace,
      key: metafieldKey,
      type: selectedMetafieldType,
      metafieldParent: metafieldParent,
      csvHeaders: selectedMetafieldType?.startsWith('list.') || selectedMetafieldType === 'json' || selectedMetafieldType === 'jsonAutomap' ? addedItems : selectedCsvHeaderForItem,
    };

    return metafieldStructure;
  };

  const handleRemoveMetafieldStructure = useCallback((indexToRemove) => {
    // If only one metafield exists, reset to default instead of removing
    if (metafieldStructures.length === 1) {
      setMetafieldStructures([metafieldDefaultMapping]);
      setMetafieldErrors([undefined]);
      setMetafieldNamespaceErrors([undefined]);
      setMetaTypeErrors([undefined]);
      setMetaKeyLengthErrors([undefined]);
      setMetaCsvHeaderErrors([undefined]);
      return;
    }

    const updatedStructures = metafieldStructures.filter((_, index) => index !== indexToRemove);
    setMetafieldStructures(updatedStructures);
    const metafieldError = metafieldErrors.filter((_, index) => index !== indexToRemove);
    setMetafieldErrors(metafieldError);
    const namespaceErrors = metafieldNamespaceErrors.filter((_, index) => index !== indexToRemove);
    setMetafieldNamespaceErrors(namespaceErrors);
    const typeErrors = metaTypeErrors.filter((_, index) => index !== indexToRemove);
    setMetaTypeErrors(typeErrors);
    const keyLengthErrors = metaKeyLengthErrors.filter((_, index) => index !== indexToRemove);
    setMetaKeyLengthErrors(keyLengthErrors);
    const csvHeaderErrors = metaCsvHeaderErrors.filter((_, index) => index !== indexToRemove);
    setMetaCsvHeaderErrors(csvHeaderErrors);
  }, [metafieldStructures, metafieldDefaultMapping, metafieldErrors, metafieldNamespaceErrors,
    metaTypeErrors, metaKeyLengthErrors, metaCsvHeaderErrors]);

  const metafieldModal = (
    <s-modal-section>
      <s-stack direction="block">
        {(selectedMetafieldType.startsWith('list.') || selectedMetafieldType === 'json' || selectedMetafieldType === 'jsonAutomap') && (
          <div>
            <s-select
              label="Select Column Header for Item"
              value={encodeOptionValue(selectedCsvHeaderForItem, headersCSV)}
              onChange={(e) => setSelectedCsvHeaderForItem(decodeOptionValue(e.currentTarget.value, headersCSV))}
            >
              {headersCSV.map((header, i) => (
                <s-option key={`meta-add-${i}`} value={String(i)}>
                  {header === "null" ? "Select a value" : header}
                </s-option>
              ))}
            </s-select>
            <div>
              {addedItems.length > 0 && selectedMetafieldType.startsWith('list.') ?
                <>
                  <s-box paddingBlockStart="300" paddingBlockEnd="300">
                    <s-heading>Added Items:</s-heading>
                  </s-box>

                  <s-stack direction="inline" gap="tight">
                    {addedItems.map((item, index) => (
                      <s-clickable-chip key={index} onClick={() => handleRemoveItem(index)}>
                        {item}
                      </s-clickable-chip>
                    ))}
                  </s-stack>
                </> : null}

            </div>
            <br />

            <s-button onClick={handleAddItem}>Add Item</s-button>
          </div>

        )}

        {(!selectedMetafieldType.startsWith('list.')) && (
          <div>
            <s-select
              label="Select Column Header for Item"
              value={encodeOptionValue(selectedCsvHeaderForItem, headersCSV)}
              onChange={(e) => setSelectedCsvHeaderForItem(decodeOptionValue(e.currentTarget.value, headersCSV))}
            >
              {headersCSV.map((header, i) => (
                <s-option key={`meta-edit-${i}`} value={String(i)}>
                  {header === "null" ? "Select a value" : header}
                </s-option>
              ))}
            </s-select>
          </div>
        )}
      </s-stack>
    </s-modal-section>
  );
  const metafieldModalAdd = (
    <s-modal
      id="metafield-modal-add"
      heading="Create Metafield"
    >
      {metafieldModal}

      <s-button
        slot="primary-action"
        variant="primary"
        commandFor="metafield-modal-add"
        command="--hide"
        onClick={() => {
          handleAddMappingAndCreateMetafield();
        }}
      >
        Add Mapping
      </s-button>
    </s-modal>
  );

  const metafieldModalEdit = (
    <s-modal
      id="metafield-modal-edit"
      heading="Edit Metafield"
    >
      {metafieldModal}

      <s-button
        slot="primary-action"
        variant="primary"
        commandFor="metafield-modal-edit"
        command="--hide"
        onClick={() => {
          handleEditMappingAndCreateMetafield();
        }}
      >
        Update Mapping
      </s-button>
    </s-modal>
  );


  const [addSuffix, setAddSuffix] = useState(false);
  const [tagSuffix, setTagSuffix] = useState('');
  const [noTag, setNoTag] = useState(false);
  const [selectedCsvHeaderForTags, setSelectedCsvHeaderForTags] = useState('');

  // Memoize select options to prevent recreation on every render
  const csvHeaderOptions = useMemo(() =>
    headersCSV.map((header) => ({ label: header === "null" ? "Select a value" : header, value: header })),
    [headersCSV]
  );

  const shopifyHeaderOptions = useMemo(() =>
    shopifyHeaders
      .filter(header => header !== 'Media Src' && header !== 'Media Alt')
      .map(header => ({ label: header === "null" ? "Select a value" : header, value: header })),
    [shopifyHeaders]
  );

  const handleAddSuffixChange = () => {
    setAddSuffix(!addSuffix);
  };

  const handleNoTagChange = () => {
    setNoTag(!noTag);
  };

  const handleRemoveTag = useCallback((indexToRemove) => {
    // If only one tag exists, reset to default instead of removing
    if (tagsStructure.length === 1) {
      setTagsStructure([tagsDefaultMapping]);
      setTagsPrefixErrors([]);
      setTagsSuffixErrors([]);
      return;
    }

    const updatedTags = tagsStructure.filter((_, index) => index !== indexToRemove);
    const tagsPreErrors = tagsPrefixErrors.filter((_, index) => index !== indexToRemove);
    setTagsPrefixErrors(tagsPreErrors);
    const tagsSufErrors = tagsSuffixErrors.filter((_, index) => index !== indexToRemove);
    setTagsSuffixErrors(tagsSufErrors);
  }, [tagsStructure, tagsDefaultMapping, tagsPrefixErrors, tagsSuffixErrors]);

  const handleAddMappingAndCreateTags = () => {
    setSelectedCsvHeader(headersCSV[0]);
    setSelectedCsvHeaderForTags(headersCSV[0]);
    setShowTagsModal(false);
  };

  // const handleAddTag = () => {
  //   if (!noTag) {
  //     const newTagStructure = {
  //       separator: tagseparator,
  //       prefix: addPrefix ? tagPrefix : '',
  //       suffix: addSuffix ? tagSuffix : '',
  //       mappedHeader: selectedCsvHeaderForTags,
  //     };
  //     const isTagStructureExist = tagsStructure.some((tagStructure) => {
  //       return (
  //         tagStructure.separator === newTagStructure.separator &&
  //         tagStructure.prefix === newTagStructure.prefix &&
  //         tagStructure.suffix === newTagStructure.suffix &&
  //         tagStructure.mappedHeader === newTagStructure.mappedHeader
  //       );
  //     });

  //     if (!isTagStructureExist) {
  //       setTagsStructure([...tagsStructure, newTagStructure]);
  //     }
  //   } else {
  //     const isTagStructureExist = tagsStructure.some((tagStructure) => {
  //       return tagStructure.mappedHeader === selectedCsvHeaderForTags &&
  //         tagStructure.separator === null &&
  //         tagStructure.prefix === null &&
  //         tagStructure.suffix === null;
  //     });

  //     if (!isTagStructureExist) {
  //       const newTagStructure = {
  //         separator: null,
  //         prefix: null,
  //         suffix: null,
  //         mappedHeader: selectedCsvHeaderForTags,
  //       };
  //       setTagsStructure([...tagsStructure, newTagStructure]);
  //     }
  //   }
  //   setAddPrefix('');
  //   setAddSuffix('');
  //   setSelectedCsvHeaderForTags(headersCSV[0]);
  // };


  // const tagsModal = (
  //   <s-modal 
  //     small
  //     open={showTagsModal}
  //     onClose={() => setShowTagsModal(false)}
  //     title="Create Tags"
  //     primaryAction={{
  //       content: 'Add Mapping',
  //       disabled: tagsStructure.length > 0 ? false : true,
  //       onAction: () => {
  //         handleAddMappingAndCreateTags();
  //       },
  //     }}
  //   >
  //     <s-modal-section>
  //       <s-stack direction="block">
  //         <s-select 
  //           label="Select Column Header for Tags"
  //           options={headersCSV.map((header) => ({ label: header === "null" ? "Select a value" : header, value: header }))}
  //           value={selectedCsvHeaderForTags}
  //           onChange={(selected) => setSelectedCsvHeaderForTags(selected)}
  //         />
  //         <s-checkbox 
  //           label="None"
  //           checked={noTag}
  //           onChange={handleNoTagChange}
  //         />

  //         {(!noTag) && (
  //           <>
  //             <s-text-field 
  //               label="Tag Separator"
  //               value={tagseparator}
  //               // disabled={true}
  //               // labelAction={{ content: 'Edit', onAction: () => setShowSettingsConfigModal(true) }}
  //               onChange={handleATagSeparatorChange}
  //             />
  //             <s-checkbox 
  //               label="Add Prefix"
  //               checked={addPrefix}
  //               onChange={handleAddPrefixChange}
  //             />
  //             <br />
  //             {addPrefix && (
  //               <div>
  //                 <s-text-field 
  //                   label="Prefix"
  //                   value={tagPrefix}
  //                   onChange={(newValue) => {
  //                     setTagPrefix(newValue);
  //                   }}
  //                   error={tagPrefix.includes(tagseparator) ? "Prefix should not contain the separator." : null}
  //                 />
  //               </div>
  //             )}

  //             {/* Add Suffix */}
  //             <s-checkbox 
  //               label="Add Suffix"
  //               checked={addSuffix}
  //               onChange={handleAddSuffixChange}
  //             />
  //             {addSuffix && (
  //               <div>
  //                 <s-text-field 
  //                   label="Suffix"
  //                   value={tagSuffix}
  //                   onChange={(newValue) => {
  //                     setTagSuffix(newValue);
  //                   }}
  //                   error={tagSuffix.includes(tagseparator) ? "Suffix should not contain the separator." : null}
  //                 />
  //               </div>
  //             )}
  //             <br />
  //             <s-button onClick={handleAddTag} disabled={tagSuffix.includes(tagseparator) ? true : false}>Add Tag</s-button>
  //           </>
  //         )}

  //         {noTag ? <s-button onClick={handleAddTag} disabled={tagSuffix.includes(tagseparator) ? true : false}>Add Tag</s-button> : null}
  //         {tagsStructure.length > 0 ? <h3>Tags</h3> : null}
  //         <div>
  //           {(selectedCsvHeaderForTags) ? (
  //             <s-stack direction="inline" wrap="wrap" spacing="tight">
  //             {tagsStructure.map((tag, index) => (
  //               <s-chip key={index} onClick={() => handleRemoveTag(index)}>
  //                 {tag.prefix == null ? (
  //                   tag.suffix == null || tag.suffix === '' ? (
  //                     tag.mappedHeader
  //                   ) : (
  //                     tag.mappedHeader + (tag.separator !== null ? tag.separator : '') + tag.suffix
  //                   )
  //                 ) : (
  //                   tag.prefix +
  //                   (tag.prefix !== '' && tag.separator !== null ? tag.separator : '') +
  //                   tag.mappedHeader +
  //                   (tag.suffix == null || tag.suffix === '' ? '' : tag.separator + tag.suffix)
  //                 )}
  //               </s-chip>
  //             ))}
  //           </s-stack>

  //           ) : null}
  //         </div>
  //       </s-stack>
  //     </s-modal-section>
  //   </s-modal>
  // );

  const handleTemplateSave = () => {
    setShowTemplateNameModal(false);
    setSaveTempLoading(true);
    const updatedMetafieldStructures = metafieldStructures.map((structure) => {
      return {
        ...structure,
        type: structure.type === "jsonAutomap" ? "json" : structure.type === "listAutoMap" ? "list" : structure.type,
      };
    });
    const finalMapping = {
      productMapping: headerMappings,
      metafieldMapping: updatedMetafieldStructures,
      imageMapping: imagePairs,
      tagsMapping: tagsStructure,
    };
    const jsonData = JSON.stringify(finalMapping);
    const formData = new FormData();
    formData.append('MappingData', jsonData);
    const requestOptions = {
      method: 'POST',
      body: formData,
    };
    const isTitleMapped = headerMappings.some((mapping) => {
      return mapping.shopifyHeaders.some((shopifyHeader) => {
        return shopifyHeader.header === "Handle";
      });
    });

    const optionHeaders = ["Option1 Name", "Option1 Value", "Option2 Name", "Option2 Value", "Option3 Name", "Option3 Value"];
    const isOptionMapped = headerMappings.some((mapping) =>
      mapping.shopifyHeaders.some((sh) =>
        optionHeaders.includes(sh.header)
      )
    );
    const isSkuMapped = headerMappings.some((mapping) =>
      mapping.shopifyHeaders.some((sh) => sh.header === "Variant Sku")
    );
    if (isOptionMapped && !isSkuMapped) {
      setProductMappingError("'Variant Sku' is required when Option Names or Values are mapped.");
      setSaveTempLoading(false);
      setTimeout(() => {
        document.querySelector('#mapping-modal s-banner[tone="critical"]')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 100);
      return;
    }

    if (isTitleMapped) {
      if (selectedTemplate === "0") {
        fetch(endpoint + '/api/TemplateMap/add?storeUrl=' + storeUrl + '&name=' + templateName + '&importType=' + uploadType, requestOptions)
          .then((response) => response.json())
          .then((data) => {

            setSaveTempLoading(false);
            handleMappingDone();
            if (currentRoute !== "preset") {
              handleSubmit('continue');
              setSaveTempLoading(false);
            }
            else {

              cancelUpload();
              setActive(false);
              setSaveTempLoading(false);
              if (setSelectedTemplateId) { setSelectedTemplateId(data?.id?.toString() ?? "0"); }
            }

          })
          .catch((error) => {
            setSaveTempLoading(false);
            console.log("currrent routedsd=", currentRoute);
            if (currentRoute !== "product" && setCompletedSteps) { setCompletedSteps((prev) => ({ ...prev, step2: false })); }
          });
      }
      else {
        fetch(endpoint + '/api/TemplateMap/update?storeUrl=' + storeUrl + '&id=' + selectedTemplate + '&name=' + templateName + '&importType=' + uploadType, requestOptions)
          .then((response) => response.json())
          .then((data) => {
            setSaveTempLoading(false);
            handleMappingDone();
            if (currentRoute !== "preset") {
              handleSubmit('continue');
              setSaveTempLoading(false);
            }
            else {
              cancelUpload();
              setActive(false);
              setSaveTempLoading(false);
            }
          })
          .catch((error) => {
            if (currentRoute !== "product" && setCompletedSteps) { setCompletedSteps((prev) => ({ ...prev, step2: false })); }
            setSaveTempLoading(false);
          });
      }
    }
    else {
      setProductMappingError("Mapping the 'Handle' Shopify header is required.");
      setSaveTempLoading(false);
    }
  }


  const handleSubmit = (type) => {
    const isTitleMapped = headerMappings.some((mapping) => {
      return mapping.shopifyHeaders.some((shopifyHeader) => {
        return shopifyHeader.header === "Handle";
      });
    });
    setProductMappingError("");
    setMetafieldMappingError("");

    if (currentRoute !== "order") {
      const optionHeaders = ["Option1 Name", "Option1 Value", "Option2 Name", "Option2 Value", "Option3 Name", "Option3 Value"];
      const isOptionMapped = headerMappings.some((mapping) =>
        mapping.shopifyHeaders.some((sh) =>
          optionHeaders.includes(sh.header)
        )
      );
      const isSkuMapped = headerMappings.some((mapping) =>
        mapping.shopifyHeaders.some((sh) => sh.header === "Variant Sku")
      );
      console.log("SKU Validation - mapped headers:", headerMappings.map(m => m.shopifyHeaders.map(sh => sh.header)), "isOptionMapped:", isOptionMapped, "isSkuMapped:", isSkuMapped);
      if (isOptionMapped && !isSkuMapped) {
        setProductMappingError("'Variant Sku' is required when Option Names or Values are mapped.");
        setSaveTempLoading(false);
        setTimeout(() => {
          document.querySelector('#mapping-modal s-banner[tone="critical"]')?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 100);
        return;
      }
    }

    if (isTitleMapped || currentRoute === "order") {
      if (type === 'show' && currentRoute === "product") {
        // Trigger template modal via command
        const button = document.querySelector('[data-open-template-modal]');
        if (button) button.click();
        return;
      }
      else if (type === 'save' && currentRoute === "product") {
        handleTemplateSave();
      }
      else {
        submitUpload();
        const updatedMetafieldStructures = metafieldStructures.map((structure) => {
          return {
            ...structure,
            type: structure.type === "jsonAutomap" ? "json" : structure.type === "listAutoMap" ? "list" : structure.type,
          };
        });

        const updatedMetafieldStructuresWithCsvHeaders = updatedMetafieldStructures.map(item => {
          if ((item.type === 'json' || item.type?.startsWith('list.')) && Array.isArray(item.csvHeaders)) {
            item.csvHeaders = item.csvHeaders.join(', ');
          }
          return item;
        });
        // tagsStructure.forEach(item => {item.separator = tagseparator; });
        const finalMapping = {
          productMapping: headerMappings,
          metafieldMapping: updatedMetafieldStructuresWithCsvHeaders,
          imageMapping: imagePairs,
          tagsMapping: tagsStructure,
        };
        const jsonData = JSON.stringify(finalMapping);
        const formData = new FormData();
        formData.append('UploadType', uploadType);
        formData.append('MappingData', jsonData);
        formData.append('ftpConfig', JSON.stringify(ftpConfig));
        uploadType == "File" ? formData.append('File', file, file?.name) : formData.append('feedUrl', file);
        formData.append('StoreUrl', storeUrl);

        const requestOptions = {
          method: 'POST',
          body: formData,
        };
        var url = "";
        if (currentRoute === "order") {
          url = '/api/Order/process-mappings';
        }
        else {
          url = '/api/ProductCustom/process-mappings';
        }
        fetch(endpoint + url, requestOptions)
          .then((response) => {
            if (response.status === 400) {
              return response.json().then((errorData) => {
                if (errorData.message.includes('metafields')) {
                  throw new Error(`Metafields: ${errorData.message}`);
                }
                else {
                  throw new Error(`Bad Request: ${errorData.message}`);
                }
              });
            } else if (!response.ok) {
              throw new Error('Server Error');
            }
            return response.json();
          })
          .then((data) => {
          })
          .catch((error) => {
            if (error.message?.startsWith('Bad Request')) {
              uploadError("server");
            }
            else if (error.message?.startsWith('Metafields')) {
              uploadError("metafield");
            }
          })
          .finally(() => {
            setActive(false);
          });
        setActive(false);
      }
    }
    else {
      setProductMappingError("Mapping the 'Handle' Shopify header is required.");
      setSaveTempLoading(false);
    }
  };

  const InputTemplateNameModal = (
    <s-modal
      id="template-name-modal"
      heading="Do you want to save this template?"
    >
      <s-modal-section>
        <s-stack direction="block">
          <s-text-field
            label="Template name"
            value={templateName}
            onInput={(e) => setTemplateName(e?.target?.value ?? e?.currentTarget?.value ?? '')}
            onChange={(e) => setTemplateName(typeof e === 'string' ? e : (e?.target?.value ?? e?.currentTarget?.value ?? ''))}
          />
        </s-stack>
      </s-modal-section>

      {currentRoute !== "preset" ?
        <s-button
          slot="secondary-actions"
          commandFor="template-name-modal"
          command="--hide"
          onClick={() => { handleSubmit('continue') }}
          style={{ display: currentRoute === "preset" ? 'none' : 'inline-block' }}
        >
          Continue without saving
        </s-button>
        : null}

      <s-button
        slot="primary-action"
        variant="primary"
        disabled={templateName === '' ? true : false}
        commandFor="template-name-modal"
        command="--hide"
        onClick={() => {
          currentRoute === "preset" ? handleTemplateSave() : handleSubmit('save');
        }}
      >
        {currentRoute === "preset" ? 'Save' : 'Save & Continue'}
      </s-button>
    </s-modal>
  );

  //////////////////////////////////////// index table mappings Start ////////////////////////////////////////


  const [itemStrings, setItemStrings] = useState([
    currentRoute !== "order" ? 'Product' : 'Order',
    currentRoute !== "order" ? 'Images' : null,
    'Tags',
    'Metafields'
  ]);


  // Removed useSetIndexFiltersMode - not needed for s-table
  const resourceName = {
    singular: 'order',
    plural: 'orders',
  };

  const [headings, setHeadings] = useState([]);


  const handleShopifyHeaderChange = (selected, mapping, shopifyHeader, index) => {
    setNewEntryValidationError("");
    setMappedShopifyHeaders((prevMappedHeaders) => new Set(prevMappedHeaders).add(selected));
    const updatedHeaderMappings = [...headerMappings];
    const currentMapping = updatedHeaderMappings.find(
      (m, i) => m.csvHeader === mapping.csvHeader && m.shopifyHeaders.some((sh) => sh.header === shopifyHeader && i === index)
    );

    if (currentMapping) {
      const specificShopifyHeader = currentMapping.shopifyHeaders.find((sh) => sh.header === shopifyHeader);
      // Check if the selected header exists in OTHER mappings (exclude current index)
      const isKeyExists = updatedHeaderMappings.find(
        (m, i) => i !== index && m.shopifyHeaders.some((sh) => sh.header === selected)
      );
      const newErrors = [...productErrors];
      if (isKeyExists) {
        newErrors[index] = selected + ' already mapped.';
      } else {
        newErrors[index] = undefined;
      }
      setProductErrors(newErrors);
      if (specificShopifyHeader) {
        specificShopifyHeader.header = selected;
      }
    }
    validateVariantOptionMappings(updatedHeaderMappings);
    setHeaderMappings(updatedHeaderMappings);
  };




  const handleMetafieldKeyChange = (newKey, index) => {
    const currentNamespace = metafieldStructures[index].namespace;
    const currentCsvHeader = metafieldStructures[index].csvHeaders;
    const isKeyExists = metafieldStructures.some((metafield, i) => metafield.key === newKey && metafield.namespace === currentNamespace && metafield.type === metafieldStructures[index].type && i !== index);
    const newErrors = [...metafieldErrors];
    const metaKeyLenErrors = [...metaKeyLengthErrors];
    const namespaceErrors = [...metafieldNamespaceErrors];
    const csvHeaderErrors = [...metaCsvHeaderErrors];

    // Group validation: if both are empty, no error
    const isKeyEmpty = !newKey || newKey.trim() === '';
    const isNamespaceEmpty = !currentNamespace || currentNamespace.trim() === '';

    if (isKeyEmpty && isNamespaceEmpty) {
      // Both empty - no validation errors
      newErrors[index] = undefined;
      metaKeyLenErrors[index] = undefined;
      namespaceErrors[index] = undefined;
      csvHeaderErrors[index] = undefined;
    } else if (!isKeyEmpty && isNamespaceEmpty) {
      // Key has value but namespace is empty
      namespaceErrors[index] = 'Namespace is required when key is provided.';
      if (newKey.length < 3) {
        metaKeyLenErrors[index] = 'Minimum is 3 characters.';
      } else {
        metaKeyLenErrors[index] = undefined;
      }
      newErrors[index] = undefined;
      // Validate CSV header
      if (currentCsvHeader === 'null' || !currentCsvHeader) {
        csvHeaderErrors[index] = 'Column header is required.';
      } else {
        csvHeaderErrors[index] = undefined;
      }
    } else if (isKeyEmpty && !isNamespaceEmpty) {
      // Namespace has value but key is empty
      metaKeyLenErrors[index] = 'Key is required when namespace is provided.';
      // Also check namespace length even though key is empty
      if (currentNamespace.length < 3) {
        namespaceErrors[index] = 'Minimum is 3 characters.';
      } else {
        namespaceErrors[index] = undefined;
      }
      newErrors[index] = undefined;
      // Validate CSV header
      if (currentCsvHeader === 'null' || !currentCsvHeader) {
        csvHeaderErrors[index] = 'Column header is required.';
      } else {
        csvHeaderErrors[index] = undefined;
      }
    } else {
      // Both have values - validate both lengths and duplicates
      if (newKey.length < 3) {
        metaKeyLenErrors[index] = 'Minimum is 3 characters.';
        newErrors[index] = undefined;
      } else if (isKeyExists) {
        newErrors[index] = 'Key already exists.';
        metaKeyLenErrors[index] = undefined;
      } else {
        newErrors[index] = undefined;
        metaKeyLenErrors[index] = undefined;
      }

      if (currentNamespace.length < 3) {
        namespaceErrors[index] = 'Minimum is 3 characters.';
      } else {
        namespaceErrors[index] = undefined;
      }

      // Validate CSV header
      if (currentCsvHeader === 'null' || !currentCsvHeader) {
        csvHeaderErrors[index] = 'Column header is required.';
      } else {
        csvHeaderErrors[index] = undefined;
      }
    }

    setMetafieldErrors(newErrors);
    setMetaKeyLengthErrors(metaKeyLenErrors);
    setMetafieldNamespaceErrors(namespaceErrors);
    setMetaCsvHeaderErrors(csvHeaderErrors);

    const updatedMappings = [...metafieldStructures];
    updatedMappings[index].key = newKey;

    setMetafieldStructures(updatedMappings);
  };


  const handleNamespaceChange = (newNamespace, index) => {
    const currentKey = metafieldStructures[index].key;
    const currentCsvHeader = metafieldStructures[index].csvHeaders;
    const isKeyExists = metafieldStructures.some((metafield, i) => metafield.key === currentKey && metafield.namespace === newNamespace && metafield.type === metafieldStructures[index].type && i !== index);
    const updatedMappings = [...metafieldStructures];
    updatedMappings[index].namespace = newNamespace;

    const newErrors = [...metafieldNamespaceErrors];
    const newKeyErrors = [...metafieldErrors];
    const keyLenErrors = [...metaKeyLengthErrors];
    const csvHeaderErrors = [...metaCsvHeaderErrors];

    // Group validation: if both are empty, no error
    const isNamespaceEmpty = !newNamespace || newNamespace.trim() === '';
    const isKeyEmpty = !currentKey || currentKey.trim() === '';

    if (isNamespaceEmpty && isKeyEmpty) {
      // Both empty - no validation errors
      newErrors[index] = undefined;
      newKeyErrors[index] = undefined;
      keyLenErrors[index] = undefined;
      csvHeaderErrors[index] = undefined;
    } else if (!isNamespaceEmpty && isKeyEmpty) {
      // Namespace has value but key is empty
      keyLenErrors[index] = 'Key is required when namespace is provided.';
      if (newNamespace.length < 3) {
        newErrors[index] = 'Minimum is 3 characters.';
      } else {
        newErrors[index] = undefined;
      }
      newKeyErrors[index] = undefined;
      // Validate CSV header
      if (currentCsvHeader === 'null' || !currentCsvHeader) {
        csvHeaderErrors[index] = 'Column header is required.';
      } else {
        csvHeaderErrors[index] = undefined;
      }
    } else if (isNamespaceEmpty && !isKeyEmpty) {
      // Key has value but namespace is empty
      newErrors[index] = 'Namespace is required when key is provided.';
      // Also check key length even though namespace is empty
      if (currentKey.length < 3) {
        keyLenErrors[index] = 'Minimum is 3 characters.';
      } else {
        keyLenErrors[index] = undefined;
      }
      newKeyErrors[index] = undefined;
      // Validate CSV header
      if (currentCsvHeader === 'null' || !currentCsvHeader) {
        csvHeaderErrors[index] = 'Column header is required.';
      } else {
        csvHeaderErrors[index] = undefined;
      }
    } else {
      // Both have values - validate both lengths and duplicates
      if (newNamespace.length < 3) {
        newErrors[index] = 'Minimum is 3 characters.';
      } else {
        newErrors[index] = undefined;
      }

      if (currentKey.length < 3) {
        keyLenErrors[index] = 'Minimum is 3 characters.';
        newKeyErrors[index] = undefined;
      } else if (isKeyExists) {
        newKeyErrors[index] = 'Key already exists.';
        keyLenErrors[index] = undefined;
      } else {
        newKeyErrors[index] = undefined;
        keyLenErrors[index] = undefined;
      }

      // Validate CSV header
      if (currentCsvHeader === 'null' || !currentCsvHeader) {
        csvHeaderErrors[index] = 'Column header is required.';
      } else {
        csvHeaderErrors[index] = undefined;
      }
    }

    setMetafieldErrors(newKeyErrors);
    setMetafieldNamespaceErrors(newErrors);
    setMetaKeyLengthErrors(keyLenErrors);
    setMetaCsvHeaderErrors(csvHeaderErrors);
    setMetafieldStructures(updatedMappings);
  }




  const displayCsvHeaders = useCallback((csvHeaders) => {
    const MAX_DISPLAY_LENGTH = 20;
    const combinedHeaders = csvHeaders.join(', ');
    if (combinedHeaders.length > MAX_DISPLAY_LENGTH) {
      const truncatedHeaders = combinedHeaders.slice(0, MAX_DISPLAY_LENGTH) + ' ...';
      return truncatedHeaders;
    }
    return combinedHeaders;
  }, []);




  const updateMapping = useMemo(() => {
    const updatedRows = [];
    if (selected === 0 || selected === 4 || selected === 5) {
      setHeadings([
        { title: 'Column Header' },
        { title: 'Shopify Field' },
        { title: 'Actions' }
      ]);
      const shopifyHeaderList = shopifyHeaders;
      headerMappings.forEach((mapping, parentIndex) => {
        const { csvHeader, shopifyHeaders } = mapping;

        shopifyHeaders.forEach((shopifyHeader, index) => {
          const mapCsvHeaderChange = (selected) => {
            const updatedCsvHeader = [...headerMappings];
            updatedCsvHeader[parentIndex] = {
              ...mapping,
              csvHeader: selected,
            };
            setNewEntryValidationError("");
            setHeaderMappings(updatedCsvHeader);
          };
          updatedRows.push(
            <s-table-row key={`${"productMap"}-${parentIndex}`}  >
              <s-table-cell>
                {/* <div style={{ maxWidth: "400px" }}> */}
                <s-select
                  value={encodeOptionValue(csvHeader, headersCSV)}
                  onChange={(e) => { mapCsvHeaderChange(decodeOptionValue(e.currentTarget.value, headersCSV)); }}
                >
                  {headersCSV.map((header, i) => (
                    <s-option key={`prod-csv-${parentIndex}-${i}`} value={String(i)}>
                      {header === "null" ? "Select a value" : header}
                    </s-option>
                  ))}
                </s-select>
                {/* </div> */}
              </s-table-cell>
              <s-table-cell key={parentIndex}>
                {/* <div style={{ maxWidth: "400px" }}> */}
                {(() => {
                  const filteredShopifyList = shopifyHeaderList.filter(header => header !== 'Media Src' && header !== 'Media Alt');
                  return (
                    <s-select
                      value={encodeOptionValue(shopifyHeader.header, filteredShopifyList)}
                      onChange={(e) => {
                        const selected = decodeOptionValue(e.currentTarget.value, filteredShopifyList);
                        if (selected === 'Metafield') {
                          setSelected(3);
                        } else if (selected === "Tags" && selectedCsvHeader.toLocaleLowerCase() !== "tags") {
                          setSelected(2);
                        } else if (selected === "Image") {
                          setSelected(1);
                        } else {
                          handleShopifyHeaderChange(selected, mapping, shopifyHeader.header, parentIndex);
                        }
                      }}
                      error={productErrors[parentIndex] || productVariantOptionErrors[parentIndex]}
                    >
                      {filteredShopifyList.map((header, i) => (
                        <s-option key={`prod-sh-${parentIndex}-${i}`} value={String(i)}>
                          {header === "null" ? "Select a value" : header}
                        </s-option>
                      ))}
                    </s-select>
                  );
                })()}
                {/* </div> */}
              </s-table-cell>
              <s-table-cell>

                <s-button-group gap="none">
                  <s-button slot="secondary-actions" tone="success" icon="minus-circle" onClick={() => handleRemoveMapping(csvHeader, shopifyHeader.header, parentIndex)}></s-button>
                  <s-button slot="secondary-actions" tone="critical" icon="plus-circle" onClick={() => {
                    const hasNullMapping = headerMappings.some(
                      mapping =>
                        mapping.csvHeader === "null" ||
                        mapping.shopifyHeaders.some(shopifyHeader => shopifyHeader.header === "null")
                    );

                    if (!hasNullMapping) {
                      setNewEntryValidationError("");
                      setHeaderMappings(prevHeaderMappings => {
                        const insertIndex = parentIndex + 1;
                        const newMappings = [...prevHeaderMappings];
                        newMappings.splice(insertIndex, 0, productDefaultMapping);
                        return newMappings;
                      });
                    }
                    else {
                      setNewEntryValidationError("Please ensure all mappings are filled with valid values before adding another.");
                    }
                  }}
                  >
                  </s-button>
                </s-button-group>
                {/* <s-button-group>
                  <s-button icon="minus-circle" onClick={() => handleRemoveMapping(csvHeader, shopifyHeader.header, parentIndex)} variant='plain' tone="critical" size="micro"></s-button>
                  <s-button
                    icon="plus-circle"
                    onClick={() => {
                      const hasNullMapping = headerMappings.some(
                        mapping =>
                          mapping.csvHeader === "null" ||
                          mapping.shopifyHeaders.some(shopifyHeader => shopifyHeader.header === "null")
                      );

                      if (!hasNullMapping) {
                        setNewEntryValidationError("");
                        setHeaderMappings(prevHeaderMappings => {
                          const insertIndex = parentIndex + 1;
                          const newMappings = [...prevHeaderMappings];
                          newMappings.splice(insertIndex, 0, productDefaultMapping);
                          return newMappings;
                        });
                      }
                      else {
                        setNewEntryValidationError("Please ensure all mappings are filled with valid values before adding another.");
                      }
                    }}
                    variant="plain"
                    tone="success"
                    size="micro"
                  />
                </s-button-group> */}
              </s-table-cell>
            </s-table-row>
          );
        });
      });
    } else if (selected === 1 && currentRoute !== "order") {
      setHeadings([
        // { title: 'Media id' },
        { title: 'Media src' },
        { title: 'Media alt' },
        { title: 'Layout' },
        { title: 'Separator' },
        { title: 'Actions' }
      ]);
      imagePairs.map((mapping, index) => {
        const { imageSrc, imageAlt, layout, separator } = mapping;

        const handleImageSrcChange = (selected) => {
          const updatedImagePairs = [...imagePairs];
          updatedImagePairs[index] = {
            ...mapping,
            imageSrc: selected,
          };
          setImagePairs(updatedImagePairs);
        };

        // const handleImageIdChange = (selected) => {
        //   const updatedImagePairs = [...imagePairs];
        //   updatedImagePairs[index] = {
        //     ...mapping,
        //     imageId: selected,
        //   };
        //   setImagePairs(updatedImagePairs);
        // };

        const handleImageAltChange = (selected) => {
          const updatedImagePairs = [...imagePairs];
          updatedImagePairs[index] = {
            ...mapping,
            imageAlt: selected,
          };
          setImagePairs(updatedImagePairs);
        };

        const handleLayoutChange = (newLayout) => {
          const updatedImagePairs = [...imagePairs];
          updatedImagePairs[index] = {
            ...mapping,
            layout: newLayout,
          };
          setImagePairs(updatedImagePairs);
        };

        const handleSeparatorChange = (newValue) => {
          const val = typeof newValue === 'string' ? newValue : (newValue?.target?.value ?? newValue?.currentTarget?.value ?? '');
          const updatedImagePairs = [...imagePairs];
          updatedImagePairs[index] = {
            ...mapping,
            separator: val,
          };
          setImagePairs(updatedImagePairs);
        };
        console.log("headersCSV", headersCSV);


        updatedRows.push(
          <s-table-row key={`${"imageMap"}-${index}`}>

            {/* <s-table-cell>
              <s-select 
                value={imageId}
                onChange={(e) => handleImageIdChange(e.currentTarget.value)}
              >
                {headersCSV.map((header) => (
                  <s-option key={header} value={header}>
                    {header === "null" ? "Select a value" : header}
                  </s-option>
                ))}
              </s-select>

            </s-table-cell> */}
            <s-table-cell>
              <s-select
                value={encodeOptionValue(imageSrc, headersCSV)}
                onChange={(e) => handleImageSrcChange(decodeOptionValue(e.currentTarget.value, headersCSV))}
              >
                {headersCSV.map((header, i) => (
                  <s-option key={`img-src-row-${index}-${i}`} value={String(i)}>
                    {header === "null" ? "Select a value" : header}
                  </s-option>
                ))}
              </s-select>

            </s-table-cell>
            <s-table-cell>
              <s-select
                value={encodeOptionValue(imageAlt, headersCSV)}
                onChange={(e) => handleImageAltChange(decodeOptionValue(e.currentTarget.value, headersCSV))}
              >
                {headersCSV.map((header, i) => (
                  <s-option key={`img-alt-row-${index}-${i}`} value={String(i)}>
                    {header === "null" ? "Select a value" : header}
                  </s-option>
                ))}
              </s-select>
            </s-table-cell>
            <s-table-cell>
              <label>
                <input
                  type="radio"
                  name={`imageLayout-${index}`}
                  checked={layout === 'row'}
                  onChange={() => handleLayoutChange('row')}
                /> Row
              </label>
              &nbsp;&nbsp;
              <label>
                <input
                  type="radio"
                  name={`imageLayout-${index}`}
                  checked={layout === 'column'}
                  onChange={() => handleLayoutChange('column')}
                /> Column
              </label>
            </s-table-cell>
            <s-table-cell>
              {layout === 'column' ? null :
                <s-text-field
                  value={separator}
                  onChange={handleSeparatorChange}
                />
              }
            </s-table-cell>
            <s-table-cell>
              <s-button-group gap="none">
                <s-button slot="secondary-actions" tone="critical" icon="minus-circle" onClick={() => handleImageRemove(index)}></s-button>
                <s-button slot="secondary-actions" tone="success" icon="plus-circle" onClick={() => {
                  const hasImgNullMapping = imagePairs.some(mapping => mapping.imageSrc === "null" || mapping.imageSrc === "null");
                  if (!hasImgNullMapping) {
                    setImagePairs((prevHeaderMappings) => [...prevHeaderMappings, imageMappingDefaultValue]);
                  } else {
                    // Handle the case where there are mappings with null values if needed
                  }
                }}></s-button>
              </s-button-group>
            </s-table-cell>
          </s-table-row>
        );
      });
    }

    else if (selected === 2) {
      setHeadings([
        { title: 'Column Header' },
        { title: 'Prefix' },
        { title: 'Suffix' },
        { title: 'Separator' },
        { title: 'Actions' }
      ]);
      tagsStructure.map((mapping, index) => {
        const { separator, prefix, suffix, mappedHeader } = mapping;
        const handleMappedHeaderChange = (selected) => {
          const updatedMappings = [...tagsStructure];
          updatedMappings[index] = {
            ...mapping,
            mappedHeader: selected,
          };
          setTagsStructure(updatedMappings);
        };

        const handlePrefixChange = (index, mapping, newValue) => {
          const val = typeof newValue === 'string' ? newValue : (newValue?.target?.value ?? newValue?.currentTarget?.value ?? '');
          const updatedMappings = [...tagsStructure];
          const newErrors = [...tagsPrefixErrors];

          if (separator && val?.includes(separator)) {
            newErrors[index] = "Prefix should not contain the separator.";
          } else {
            newErrors[index] = undefined;
          }

          setTagsPrefixErrors(newErrors);

          updatedMappings[index] = {
            ...mapping,
            prefix: val,
          };
          setTagsStructure(updatedMappings);
        };


        const handleATagSeparatorChange = (newValue) => {
          const val = typeof newValue === 'string' ? newValue : (newValue?.target?.value ?? newValue?.currentTarget?.value ?? '');
          const updatedMappings = [...tagsStructure];
          updatedMappings[index] = {
            ...mapping,
            separator: val,
          };
          setTagsStructure(updatedMappings);
        };

        const handleSuffixChange = (newValue) => {
          const val = typeof newValue === 'string' ? newValue : (newValue?.target?.value ?? newValue?.currentTarget?.value ?? '');
          const updatedMappings = [...tagsStructure];
          const newErrors = [...tagsSuffixErrors];

          if (separator && val?.includes(separator)) {
            newErrors[index] = "Suffix should not contain the separator.";
          } else {
            newErrors[index] = undefined;
          }

          setTagsSuffixErrors(newErrors);
          updatedMappings[index] = {
            ...mapping,
            suffix: val,
          };
          setTagsStructure(updatedMappings);
        };


        updatedRows.push(
          <s-table-row key={`${"tagMap"}-${index}`}>
            <s-table-cell>
              {/* <div style={{ maxWidth: "200px" }}> */}
              <s-select
                value={encodeOptionValue(mappedHeader, headersCSV)}
                onChange={(e) => handleMappedHeaderChange(decodeOptionValue(e.currentTarget.value, headersCSV))}
              >
                {headersCSV.map((header, i) => (
                  <s-option key={`tag-hdr-${index}-${i}`} value={String(i)}>
                    {header === "null" ? "Select a value" : header}
                  </s-option>
                ))}
              </s-select>
              {/* </div> */}
            </s-table-cell>
            <s-table-cell>
              <s-text-field
                value={prefix}
                onChange={(value) => handlePrefixChange(index, mapping, value)}
                error={tagsPrefixErrors[index]}
              />
            </s-table-cell>
            <s-table-cell>
              <s-text-field
                value={suffix}
                onChange={(newValue) => handleSuffixChange(newValue)}
                error={tagsSuffixErrors[index]}
              />
            </s-table-cell>
            <s-table-cell>
              <s-text-field id={index}
                value={separator}
                // disabled={true}
                // suffix={<s-button onClick={() => setShowSettingsConfigModal(true)} variant='plain'  size="micro">Edit</s-button>}
                onChange={(newValue) => handleATagSeparatorChange(newValue)}
              />
            </s-table-cell>
            <s-table-cell>
              <s-button-group gap="none">
                <s-button slot="secondary-actions" tone="critical" icon="minus-circle" onClick={() => handleRemoveTag(index)}></s-button>
                <s-button slot="secondary-actions" tone="success" icon="plus-circle" onClick={() => {
                  const hasTagNullMapping = tagsStructure.some(mapping => mapping.mappedHeader === "null");
                  if (!hasTagNullMapping) {
                    setTagsStructure((prevHeaderMappings) => [...prevHeaderMappings, tagsDefaultMapping]);
                  } else {
                    // Handle the case where there are mappings with null values if needed
                  }
                }}></s-button>
              </s-button-group>
            </s-table-cell>
          </s-table-row>
        );
      });

    }

    else if (selected === 3) {

      const handleJsonListMetaEdit = (index) => {
        setMetafieldParent(metafieldStructures[index].metafieldParent);
        setMetafieldKey(metafieldStructures[index].key);
        setMetafieldNamespace(metafieldStructures[index].namespace);
        setSelectedMetafieldType(metafieldStructures[index].type);
        if (Array.isArray(metafieldStructures[index].csvHeaders)) {
          setAddedItems(metafieldStructures[index].csvHeaders);
        } else {
          if (metafieldStructures[index].csvHeaders !== "null") { setAddedItems([metafieldStructures[index].csvHeaders]); }
        }
        if (!Array.isArray(metafieldStructures[index].csvHeaders)) {
          setSelectedCsvHeaderForItem(metafieldStructures[index].csvHeaders);
        }
        // Trigger modal via button command
        const editButton = document.querySelector(`[data-metafield-edit-${index}]`);
        if (editButton) editButton.click();
      }
      setHeadings([
        { title: 'Column Header' },
        { title: 'Parent' },
        { title: 'Namespace' },
        { title: 'Key' },
        { title: 'Type' },
        { title: 'Actions' }
      ]);

      metafieldStructures.map((mapping, index) => {
        const { metafieldParent, key, namespace, csvHeaders, type } = mapping;

        const handleCsvHeaderChange = (selected) => {
          const updatedMappings = [...metafieldStructures];
          updatedMappings[index] = {
            ...mapping,
            csvHeaders: selected,
          };

          // Validate CSV header selection
          const csvHeaderErrors = [...metaCsvHeaderErrors];
          const currentKey = metafieldStructures[index].key;
          const currentNamespace = metafieldStructures[index].namespace;
          const isKeyEmpty = !currentKey || currentKey.trim() === '';
          const isNamespaceEmpty = !currentNamespace || currentNamespace.trim() === '';

          // Only validate CSV header if namespace or key has value
          if (!isKeyEmpty || !isNamespaceEmpty) {
            if (selected === 'null' || !selected) {
              csvHeaderErrors[index] = 'Column header is required.';
            } else {
              csvHeaderErrors[index] = undefined;
            }
          } else {
            csvHeaderErrors[index] = undefined;
          }

          setMetaCsvHeaderErrors(csvHeaderErrors);
          setMetafieldStructures(updatedMappings);
        };

        const handleMetafieldParentChange = (selected) => {
          const updatedMappings = [...metafieldStructures];
          updatedMappings[index] = {
            ...mapping,
            metafieldParent: selected,
          };
          setMetafieldStructures(updatedMappings);
        };



        const handleMetafieldTypeChange = (selected, index) => {
          const currentKey = metafieldStructures[index].key;
          const currentNamespace = metafieldStructures[index].namespace;
          const isKeyExists = metafieldStructures.some((metafield, i) => metafield.key === currentKey && metafield.namespace === currentNamespace && metafield.type === selected && i !== index);
          const updatedMappings = [...metafieldStructures];
          updatedMappings[index] = {
            ...mapping,
            type: selected,
          };
          const newErrors = [...metaTypeErrors];
          const keyErrors = [...metafieldErrors];
          const keyLenErrors = [...metaKeyLengthErrors];
          const namespaceErrors = [...metafieldNamespaceErrors];

          // Group validation: if both namespace and key are empty, don't require type
          const isKeyEmpty = !currentKey || currentKey.trim() === '';
          const isNamespaceEmpty = !currentNamespace || currentNamespace.trim() === '';

          if (isKeyEmpty && isNamespaceEmpty) {
            // Both empty - no type validation required
            newErrors[index] = undefined;
            keyErrors[index] = undefined;
            keyLenErrors[index] = undefined;
            namespaceErrors[index] = undefined;
          } else if (selected === 'null') {
            newErrors[index] = 'Type is required.';
          } else if (isKeyExists) {
            newErrors[index] = 'key with the same namespace and type already exists';
          } else {
            newErrors[index] = undefined;
          }

          setMetaTypeErrors(newErrors);
          setMetafieldErrors(keyErrors);
          setMetaKeyLengthErrors(keyLenErrors);
          setMetafieldNamespaceErrors(namespaceErrors);
          setMetafieldStructures(updatedMappings);
          if (selected?.startsWith('list.')) {
            setMetafieldParent(metafieldStructures[index].metafieldParent);
            setMetafieldKey(metafieldStructures[index].key);
            setMetafieldNamespace(metafieldStructures[index].namespace);
            setSelectedMetafieldType(selected);
            setSelectedCsvHeaderForItem(metafieldStructures[index].csvHeaders);
            if (Array.isArray(metafieldStructures[index].csvHeaders)) {
              setAddedItems(metafieldStructures[index].csvHeaders);
            } else {
              if (metafieldStructures[index].csvHeaders !== "null") { setAddedItems([metafieldStructures[index].csvHeaders]); }
            }
            setShowMetafieldModalEdit(true);
          }
        };

        updatedRows.push(
          <s-table-row>
            <s-table-cell>
              {/* <div style={{ maxWidth: "200px" }}> */}
              {type === 'json' || type.startsWith('list.') ? (
                <>
                  {Array.isArray(csvHeaders) ?
                    <s-stack direction="inline">
                      <div id={`csv-headers-tooltip-${index}`}>
                        <s-text>{displayCsvHeaders(csvHeaders)}</s-text>
                      </div>
                      <s-tooltip
                        interestFor={`csv-headers-tooltip-${index}`}
                        content={csvHeaders?.join(', ')}
                        disabled={csvHeaders.length <= 20}
                      ></s-tooltip>
                    </s-stack>
                    : <s-select
                      value={encodeOptionValue(csvHeaders, headersCSV)}
                      onChange={(e) => handleCsvHeaderChange(decodeOptionValue(e.currentTarget.value, headersCSV))}
                      error={metaCsvHeaderErrors[index]}
                    >
                      {headersCSV.map((header, i) => (
                        <s-option key={`mf-csv-json-${index}-${i}`} value={String(i)}>
                          {header === "null" ? "Select a value" : header}
                        </s-option>
                      ))}
                    </s-select>}
                </>
              ) : (
                <div>
                  <div id={`csv-headers-select-${index}`}>
                    <s-select
                      value={encodeOptionValue(csvHeaders, headersCSV)}
                      onChange={(e) => handleCsvHeaderChange(decodeOptionValue(e.currentTarget.value, headersCSV))}
                      error={metaCsvHeaderErrors[index]}
                    >
                      {headersCSV.map((header, i) => (
                        <s-option key={`mf-csv-${index}-${i}`} value={String(i)}>
                          {header === "null" ? "Select a value" : header}
                        </s-option>
                      ))}
                    </s-select>
                  </div>
                  <s-tooltip interestFor={`csv-headers-select-${index}`} content={csvHeaders}></s-tooltip>
                </div>
              )}
              {/* </div> */}
            </s-table-cell>

            <s-table-cell>
              <s-select
                value={metafieldParent}
                onChange={(e) => handleMetafieldParentChange(e.currentTarget.value)}
              >
                {currentRoute === "order"
                  ? <s-option value="order">Order</s-option>
                  : <>
                    <s-option value="product">Product</s-option>
                    <s-option value="variant">Variant</s-option>
                  </>
                }
              </s-select>
            </s-table-cell>



            <s-table-cell>
              <div id={`namespace-field-${index}`}>
                <s-text-field
                  key={csvHeaders}
                  value={namespace}
                  onChange={(e) => {
                    const val = typeof e === 'string' ? e : (e?.target?.value ?? e?.currentTarget?.value ?? '');
                    handleNamespaceChange(val, index);
                  }}
                  error={metafieldNamespaceErrors[index]}
                />
              </div>
              <s-tooltip interestFor={`namespace-field-${index}`} content={namespace}></s-tooltip>
            </s-table-cell>

            <s-table-cell>
              <div id={`key-field-${index}`}>
                <s-text-field
                  key={csvHeaders}
                  value={key}
                  onChange={(e) => {
                    const val = typeof e === 'string' ? e : (e?.target?.value ?? e?.currentTarget?.value ?? '');
                    handleMetafieldKeyChange(val, index);
                  }}
                  error={metafieldErrors[index] || metaKeyLengthErrors[index]}
                />
              </div>
              <s-tooltip interestFor={`key-field-${index}`} content={key}></s-tooltip>
            </s-table-cell>

            <s-table-cell>
              <div id={`type-field-${index}`}>
                <s-select
                  value={type === 'jsonAutomap' ? 'json' : type === 'listAutoMap' ? 'list' : type}
                  onChange={(e) => {
                    const selected = e.currentTarget.value;
                    handleMetafieldTypeChange(selected === 'jsonAutomap' ? 'json' : selected === 'listAutoMap' ? 'list' : selected, index);
                  }}
                  error={metaTypeErrors[index]}
                >
                  {metafieldTypeOptions.map((option) => (
                    <s-option key={option.value} value={option.value}>
                      {option.label}
                    </s-option>
                  ))}
                </s-select>
              </div>
              <s-tooltip interestFor={`type-field-${index}`} content={type === 'jsonAutomap' ? 'json' : type === 'listAutoMap' ? 'list' : type}></s-tooltip>
            </s-table-cell>

            <s-table-cell>
              <s-button-group gap="none">
                <s-button slot="secondary-actions" tone="critical" icon="minus-circle" onClick={() => handleRemoveMetafieldStructure(index)}></s-button>
                {(type.startsWith('list.')) ? (
                  <s-button
                    slot="secondary-actions"
                    icon="edit"
                    commandFor="metafield-modal-edit"
                    command="--show"
                    data-metafield-edit={index}
                    onClick={() => handleJsonListMetaEdit(index)}
                  ></s-button>
                ) : null}
                <s-button slot="secondary-actions" tone="success" icon="plus-circle" onClick={() => {
                  const hasMetaNullMapping = metafieldStructures.some(mapping => mapping.csvHeaders === "null");
                  if (!hasMetaNullMapping) {
                    setMetafieldStructures((prevHeaderMappings) => [...prevHeaderMappings, metafieldDefaultMapping]);
                  } else {
                    // Handle the case where there are mappings with null values if needed
                  }
                }}></s-button>
              </s-button-group>
            </s-table-cell>
          </s-table-row>
        );
      });
    }
    // setRows(updatedRows);
    // { validateVariantOptionMappings(headerMappings) }
    return updatedRows;
  }, [headerMappings, selected, imagePairs, metafieldStructures, tagsStructure, headersCSV, shopifyHeaders]);

  const tabsData = useMemo(() => {
    return itemStrings.map((item, index) => {
      if (!item) return null;

      let badgeValue = 0;
      let badgeErrorValue = 0;

      if (index === 0) {
        badgeValue = headerMappings.length;
        if ((productErrors.length === 0 || productErrors.every(error => error === undefined)) &&
          (productVariantOptionErrors.length === 0 || productVariantOptionErrors.every(error => error === undefined))) {
          badgeErrorValue = 0;
        } else {
          badgeErrorValue = 1;
        }
      } else if (index === 1 && currentRoute !== "order") {
        const isMappedHeaderNull = imagePairs?.length === 1 && imagePairs[0]?.imageSrc === "null";
        badgeValue = isMappedHeaderNull ? 0 : imagePairs?.length;
      } else if (index === 2) {
        const isMappedHeaderNull = tagsStructure?.length === 1 && tagsStructure[0]?.mappedHeader === "null";
        badgeValue = isMappedHeaderNull ? 0 : tagsStructure?.length;
        if ((tagsPrefixErrors.length === 0 || tagsPrefixErrors.every(error => error === undefined)) &&
          (tagsSuffixErrors.length === 0 || tagsSuffixErrors.every(error => error === undefined))) {
          badgeErrorValue = 0;
        } else {
          badgeErrorValue = 1;
        }
      } else if (index === 3) {
        const isMappedHeaderNull = metafieldStructures?.length === 1 && metafieldStructures[0]?.csvHeaders === "null";
        badgeValue = isMappedHeaderNull ? 0 : metafieldStructures?.length;
        if ((metafieldErrors.length === 0 || metafieldErrors.every(error => error === undefined)) &&
          (metafieldNamespaceErrors.length === 0 || metafieldNamespaceErrors.every(error => error === undefined)) &&
          (metaTypeErrors.length === 0 || metaTypeErrors.every(error => error === undefined)) &&
          (metaCsvHeaderErrors.length === 0 || metaCsvHeaderErrors.every(error => error === undefined)) &&
          (metaKeyLengthErrors.length === 0 || metaKeyLengthErrors.every(error => error === undefined))) {
          badgeErrorValue = 0;
        } else {
          badgeErrorValue = 1;
        }
      }

      // Skip null items for order route
      if (currentRoute === "order" && index === 1) {
        return null;
      }

      return {
        id: `${item}-${index}`,
        content: (
          <s-stack direction="inline" gap="small" alignment="center">
            <span>{item}</span>
            <s-chip>{badgeValue}</s-chip>
            {badgeErrorValue !== 0 && (
              <s-icon type="alert-diamond" tone="critical" />
            )}
          </s-stack>
        ),
        panelContent: null // Content rendered separately below
      };
    }).filter(Boolean);
  }, [itemStrings, headerMappings, imagePairs, tagsStructure, metafieldStructures, currentRoute,
    productErrors, productVariantOptionErrors, tagsPrefixErrors, tagsSuffixErrors,
    metafieldErrors, metafieldNamespaceErrors, metaTypeErrors, metaCsvHeaderErrors, metaKeyLengthErrors]);

  const mappedIndexTable = (
    <s-stack direction="block" gap="none">
      <s-box padding="none" borderRadius="none">
        <MappingTabs
          tabs={tabsData}
          selected={selected}
          onSelect={(newSelected) => {
            if (newSelected !== selected) {
              setSelected(newSelected);
            }
          }}
          fitted={true}
        />
      </s-box>
      <s-box padding="none">
        <s-table key={"mappingTable"}>
          <s-table-header-row>
            {headings.map((heading, index) => (
              <s-table-header key={index}>{heading.title}</s-table-header>
            ))}
          </s-table-header-row>
          <s-table-body>
            {updateMapping}
          </s-table-body>
        </s-table>
        {showSettingsConfigModal ? <SettingsConfig activate={true} onCloseSettingsModal={onCloseSettingsModal} /> : null}
      </s-box>
    </s-stack>
  );



  //////////////////////////////////////// index table mappings End ////////////////////////////////////////
  const isSubmitDisabled = !(
    (metafieldErrors.length === 0 || metafieldErrors.every(error => error === undefined)) &&
    (metaKeyLengthErrors.length === 0 || metaKeyLengthErrors.every(error => error === undefined)) &&
    (metafieldNamespaceErrors.length === 0 || metafieldNamespaceErrors.every(error => error === undefined)) &&
    (metaCsvHeaderErrors.length === 0 || metaCsvHeaderErrors.every(error => error === undefined)) &&
    (productErrors.length === 0 || productErrors.every(error => error === undefined)) &&
    (metaTypeErrors.length === 0 || metaTypeErrors.every(error => error === undefined)) &&
    (tagsPrefixErrors.length === 0 || tagsPrefixErrors.every(error => error === undefined)) &&
    (tagsSuffixErrors.length === 0 || tagsSuffixErrors.every(error => error === undefined)) &&
    (productVariantOptionErrors.length === 0 || productVariantOptionErrors.every(error => error === undefined))
  );

  const mappingWithoutModal = (
    <>
      {mappingProductError !== "" && (
        <>
          <s-banner tone="critical">{mappingProductError}</s-banner>
        </>
      )}
      {newEntryValidationError !== "" ? <><s-banner tone="warning">{newEntryValidationError}</s-banner></> : null}
      {mappedIndexTable}
      {/* Always render modals - visibility controlled by commandFor */}
      {metafieldModalAdd}
      {metafieldModalEdit}
      {currentRoute !== "order" && imageModal}
      {currentRoute !== "order" && InputTemplateNameModal}

      {/* Hidden button to trigger template modal */}


      <s-button
        variant="primary"
        size="large"
        disabled={isSubmitDisabled}
        commandFor={currentRoute === "preset" ? "template-name-modal" : undefined}
        command={currentRoute === "preset" ? "--show" : undefined}
        onClick={() => {
          if (currentRoute !== "preset") {
            handleSubmit("show");
          }
        }}
      >
        Save preset
      </s-button>

      <s-button
        style={{ display: 'none' }}
        variant="tertiary"
        data-open-template-modal-preset
        commandFor="template-name-modal"
        command="--show"
      ></s-button>
    </>
  )

  console.log(`STATE UPDATED CSV: ${headersCSV.length} | Shopify: ${shopifyHeaders.length} hasValidHeaders: ${hasValidHeaders}`)
  const modalMappping = (
    <s-modal
      id="mapping-modal"
      heading="Map Column Headers to Shopify Fields"
      size="large-100"
      padding="none"
      open={active}
    >
      <s-box padding= {currentRoute !== "preset" ? "base" : "none"}>
        <s-stack gap="large" padding="none">
          {existingTemplates.length >= 1 && currentRoute !== "preset" && (
            <s-select
              label="Select template"
              value={selectedTemplate.toString()}
              onChange={(e) => { handleTemplateSelectChange(e.currentTarget.value) }}
            >
              {existingTemplates.map((temp) => (
                <s-option key={temp.id} value={temp.id.toString()}>
                  {temp.name}
                </s-option>
              ))}
            </s-select>
          )}
          {currentRoute !== "preset" && (
            <s-stack direction="inline" gap="small" alignment="start">
              <s-button
                onClick={() => { autoMapHeaders(headersCSV, shopifyHeaders) }}
                disabled={selectedTemplate === "0" ? false : true}
              >
                Auto Map
              </s-button>
              {Object.keys(headerMappings).length > 0 && (
                <s-button onClick={handleClearAllMappings}>
                  Clear All
                </s-button>
              )}
            </s-stack>
          )}
          {mappingProductError !== "" && (
            <s-banner tone="critical">{mappingProductError}</s-banner>
          )}
          {newEntryValidationError !== "" && (
            <s-banner tone="warning">{newEntryValidationError}</s-banner>
          )}

        </s-stack>

      </s-box>
      {mappedIndexTable}
      {mappingProductError !== "" && (
        <s-box padding="base">
          <s-banner tone="critical">{mappingProductError}</s-banner>
        </s-box>
      )}
      {/* Always render modals - visibility controlled by commandFor */}
      {metafieldModalAdd}
      {metafieldModalEdit}
      {currentRoute !== "order" && imageModal}
      {currentRoute !== "order" && InputTemplateNameModal}

      {/* Hidden button to trigger template modal from handleSubmit */}
      <s-button
        variant="tertiary"
        style={{ display: 'none' }}
        data-open-template-modal
        commandFor="template-name-modal"
        command="--show"
      ></s-button>

      <s-button
        slot="secondary-actions"
        commandFor="mapping-modal"
        command="--hide"
        onClick={() => {
          cancelUpload();
          setActive(false);
        }}
      >
        Cancel
      </s-button>
      <s-button
        slot="primary-action"
        variant="primary"
        loading={false}
        disabled={(metafieldErrors.length === 0 || metafieldErrors.every(error => error === undefined)) &&
          (metaKeyLengthErrors.length === 0 || metaKeyLengthErrors.every(error => error === undefined)) &&
          (metafieldNamespaceErrors.length === 0 || metafieldNamespaceErrors.every(error => error === undefined)) &&
          (metaCsvHeaderErrors.length === 0 || metaCsvHeaderErrors.every(error => error === undefined)) &&
          (productErrors.length === 0 || productErrors.every(error => error === undefined)) &&
          (metaTypeErrors.length === 0 || metaTypeErrors.every(error => error === undefined)) &&
          (tagsPrefixErrors.length === 0 || tagsPrefixErrors.every(error => error === undefined)) &&
          (tagsSuffixErrors.length === 0 || tagsSuffixErrors.every(error => error === undefined)) &&
          (productVariantOptionErrors.length === 0 || productVariantOptionErrors.every(error => error === undefined)) ? false : true}
        commandFor={currentRoute === "preset" ? "template-name-modal" : undefined}
        command={currentRoute === "preset" ? "--show" : undefined}
        onClick={() => {
          if (currentRoute === "product") {
            handleSubmit('show');
          } else if (currentRoute !== "preset") {
            // For order or other routes, submit directly
            handleSubmit('continue');
          }
        }}
      >
        Submit
      </s-button>
    </s-modal>
  );
  // if (uploadType === "product" || uploadType === "variant" || uploadType === "order") {
  //   return (
  //     { modalMappping }
  //   )
  // }
  // else {
  //   return (
  //     { mappingWithoutModal }
  //   );
  // }

  // return (
  //   <>
  //     {hasValidHeaders ? ReactDOM.createPortal(modalMappping, document.body) :
  //       <s-box padding="400">
  //         <s-stack direction="block" alignment="center" gap="large" style={{ minHeight: '400px', justifyContent: 'center' }}>
  //           <s-spinner size="large" />
  //           <s-text alignment="center">Loading headers...</s-text>
  //         </s-stack>
  //       </s-box>}
  //     {(uploadType === "product" || uploadType === "variant" || uploadType === "order" || uploadType === "File") ? null : mappingWithoutModal}
  //   </>
  // );

  const tableSpinner = (
    <s-box padding="400">
      <s-stack direction="block" alignment="center" gap="large" style={{ minHeight: '400px', justifyContent: 'center' }}>
        <s-spinner size="large" />
      </s-stack>
    </s-box>
  );

  return (
    <>
      {!hasValidHeaders ? tableSpinner :
        (uploadType === "product" || uploadType === "variant" || uploadType === "order" || uploadType === "File") ? modalMappping : mappingWithoutModal}
    </>
  );

  function getTemplates() {
    setIndexTableLoading(true);
    getMappedTemplates(storeUrl, uploadType).then(function (result) {
      if (result !== null) {

        const existingTemp = [{
          id: 0,
          name: "New",
          template: "{}"
        }];
        existingTemp.push(...result);
        setExistingTemplates(existingTemp);
        if (currentRoute === "preset") {
          handleTemplateSelectChange(templateEditId, existingTemp);
        }
        else {
          setIndexTableLoading(false);
        }
      }
      else {
        setIndexTableLoading(false);
      }
    });
  }


  function handleTemplateSelectChange(selectedTempId, existingTemp = existingTemplates) {
    setIndexTableLoading(true);
    setSelectedTemplate(selectedTempId.toString());
    setTemplateName(existingTemp.find(temp => temp.id === parseInt(selectedTempId))?.name);
    if (selectedTempId !== '0') {
      templateMap(selectedTempId, existingTemp);
    }

    else {
      setHeaderMappings([productDefaultMapping]);
      setTagsStructure([tagsDefaultMapping]);
      setMetafieldStructures([metafieldDefaultMapping]);
      setImagePairs([imageMappingDefaultValue]);
      setTemplateName('')
      setTempLoading(false);
      setIndexTableLoading(false);
    }
  }


  function templateMap(selected, existingTemp) {
    var template = existingTemp?.find(temp => temp.id === parseInt(selected))?.template;
    if (template) {
      const templateObject = JSON.parse(template);
      const updatedMetafieldStructures = templateObject.metafieldMapping.map((structure) => {
        return {
          ...structure,
          type: structure.type === "json" ? "jsonAutomap" : structure.type?.startsWith("list.") ? structure.type : structure.type,
        };
      });

      validateVariantOptionMappings(headerMappings);

      setHeaderMappings(templateObject.productMapping);
      setTagsStructure(templateObject.tagsMapping);
      setMetafieldStructures(updatedMetafieldStructures);
      setImagePairs(templateObject.imageMapping);
      const newTypeErrors = Array(updatedMetafieldStructures.length).fill(undefined);
      const newErrors = Array(updatedMetafieldStructures.length).fill(undefined);
      const newNamespaceErrors = Array(updatedMetafieldStructures.length).fill(undefined);
      const newKeyErrors = Array(updatedMetafieldStructures.length).fill(undefined);
      updatedMetafieldStructures.forEach((metafieldMapping, mappingIndex) => {
        // const isKeyExists = updatedMetafieldStructures.some((metafield) => metafield.key === metafieldMapping.key);

        const isTypeInOptions = metafieldTypeOptions.some((option) => option.value === (metafieldMapping.type === "jsonAutomap" ? "json" : metafieldMapping.type));
        if (!isTypeInOptions) {
          newTypeErrors[mappingIndex] = 'Type is required.';
        }
        if (metafieldMapping?.key && metafieldMapping.key.length > 0 && metafieldMapping.key.length < 3) {
          newKeyErrors[mappingIndex] = 'minimum is 3 characters.';
        }
        if (metafieldMapping?.namespace && metafieldMapping.namespace.length > 0 && metafieldMapping.namespace.length < 3) {
          newNamespaceErrors[mappingIndex] = 'minimum is 3 characters.';
        }
      });
      const seenKeys = {};
      updatedMetafieldStructures.forEach((metafieldMapping, mappingIndex) => {
        if (metafieldMapping.key !== "null") {
          const keyWithNamespace = `${metafieldMapping.namespace}:${metafieldMapping.key}:${metafieldMapping.metafieldParent}:${metafieldMapping.type}`
          if (seenKeys[keyWithNamespace]) {
            newErrors[mappingIndex] = 'Key already exists within the same namespace.';
          } else {
            seenKeys[keyWithNamespace] = true;
          }
        }
      });
      setMetaTypeErrors(newTypeErrors);
      setMetafieldErrors(newErrors);
      setMetaKeyLengthErrors(newKeyErrors);
      setMetafieldNamespaceErrors(newNamespaceErrors)
      setTempLoading(false);
      setIndexTableLoading(false);
    }
  }
}